import { t } from "i18next";
import moment from "moment";

import { configFun } from "../config";
import i18n from "../i18n";
import { updateSellingFormObject } from "../redux/actions";
import store from "../redux/store";
import { lookups } from "../services/lookups";
import {
  newPropertyPlanWithRegisteredReport,
  newRegisteredProperty,
  newRegisteredPropertyWithPropertyPlanAndCoordinates,
  newRegisteredPropertyWithPropertyPlanAndCoordinatesAndChangeStatement,
  newRegisteredWithPropertyPlanAndChangeStatement,
} from "../services/quickServices";

const environmentReleases = {
  production: ["1"],
  stg: ["1", "2"],
  agiletz: ["1", "2", "3"],
};

const environmentEnLang = {
  production: false,
  stg: false,
  agiletz: true,
};

const fallBackEnv = "production";

export const servicesList = () => {
  return configFun().services.filter((service) =>
    environmentReleases[process.env.REACT_APP_ENV || fallBackEnv].includes(
      service.release,
    ),
  );
};
export const quickServicesList = () => {
  const mostWantedServices = [
    {
      title: t("home.giveaway"),
      url: "/my-properties",
      release: "1",
    },
    {
      title: t("quickServices.qushanTitle"),
      url: "/government-services/dls/quick-services/registered-property/apply",
      release: "1",
    },
    {
      title: t("quickServices.landPlanningTitle"),
      url: "/government-services/dls/quick-services/land-planning/apply",
      release: "1",
    },
    {
      title: t("quickServices.propertyDisclosure"),
      url: "/government-services/dls/quick-services/property-disclousre/apply",
      release: "1",
    },
    {
      title: t("governmentServices.requestLicence"),
      url: "/government-services/dls/real-estate-office/grant/apply",
      release: "1",
      unpublished: true,
    },
    {
      title: t("quickServices.qushanAgent"),
      url: "/government-services/dls/quick-services/registered-property-authorization/apply",
      release: "1",
    },
    {
      title: t("quickServices.changeStatement"),
      url: "/government-services/dls/quick-services/change-statement/apply",
      release: "1",
    },
    {
      title: t("quickServices.noProperty"),
      url: "/government-services/dls/quick-services/no-properties/apply",
      release: "1",
    },
  ];
  return mostWantedServices.filter((service) =>
    environmentReleases[process.env.REACT_APP_ENV || fallBackEnv].includes(
      service.release,
    ),
  );
};

export const servicesCategoriesList = () => {
  return configFun().servicesItems.filter((service) =>
    environmentReleases[process.env.REACT_APP_ENV || fallBackEnv].includes(
      service.release,
    ),
  );
};

export const resetAdjective = (formik) => {
  formik.setValues({
    ...formik.values,
    isJordanianAgent: true,
    isInternalAgency: true,
    isJordanianClient: true,
    agencyNumber: "",
    attachAgency: "",
    attachAgency2: "",
    agencyDate: "",
    agencyPlace: "",
    agentName: "",
    agencyClientName: "",
    agencyType: "",
    agencyStatus: "",
    agentNationalId: "",
    agentPersonalNumber: "",
    agentInfo: {},
    agentCardNo: "",

    clientNationalId: "",
    clientPersonalNumber: "",
    isJordanianGuardian: true,
    isJordanianMinor: true,
    guardianNationalId: "",
    guardianPersonalNumber: "",
    guardianshipNumber: "",
    salesAuthorizationNumber: "",
    minorNationalId: "",
    minorPersonalNumber: "",

    guardianName: "",
    guardianshipDate: "",
    guardianshipPlace: "",
    guardianCardNo: "",
    guardianshipAttachment: "",
    salesAuthorizationDate: "",
    salesAuthorizationPlace: "",
    salesAuthorizationAttachment: "",
    minorName: "",
    selectedArguments: [],
    mainArgumentType: "",
    secondaryArgumentType: "",

    isJordanianDeputy: true,

    entityNum: "",
    entityName: "",
    deputyNum: "",
    deputyDate: "",
    phoneNum: "",
    deputyAttach: "",
    deputyInfo: {},
    deputyNationalId: "",
    deputyPersonalNumber: "",
    deputyCardNo: "",
    guardianInfo: {},
    // companyName: "",
    // entityCode: "",
    // companyNumber: "",
    // investmentApproval: "",
  });
};

export const showLangOptions = () =>
  environmentEnLang[process.env.REACT_APP_ENV || fallBackEnv];

export const isNumber = (value) => {
  return value && /^\d*$/.test(value);
};

export const isArabic = () => {
  return i18n.language === "ar";
};

export const isFormValid = (formik, name) => {
  return !!(formik.touched[name] && formik.errors[name]);
};

export const isFormValidForArrayItems = (formik, name) => {
  return !!formik.errors[name];
};

export const getFormErrorMessageForArrayItems = (formik, name) => {
  return (
    isFormValidForArrayItems(formik, name) && (
      <small className="p-error text-xs">{formik.errors[name]}</small>
    )
  );
};

export const phoneNumValidation = (value) => {
  // return value && /^00?((9627|7)([789])|6)\d{7}$/.test(value);
  return value && /^((9627|\+9627|009627|07|7)([789])|6)\d{7}$/.test(value);
};
export const cellPhoneNumValidation = (value) => {
  return value && /^((9627|\+9627|009627|07)([789]))\d{7}$/.test(value);
};
// export const landPhoneNumValidation = (value) => {
//   return value && /^((9626|\+9626|009626|06))\d{7}$/.test(value);
// };
export const landPhoneNumValidation = (value) => {
  return value && /^((962\d|\+962\d|00962\d|0\d))\d{7}$/.test(value);
};
export const emailValidation = (value) => {
  const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  return value && emailRegex.test(value);
};

export const internationalPhoneValidation = (value) => {
  if (!value) return false;
  const trimmed = String(value).trim();
  // Allow optional leading +, then digits with optional spaces, hyphens, dots, or parentheses
  if (!/^\+?[\d\s\-().]{6,25}$/.test(trimmed)) {
    return false;
  }
  const digits = trimmed.replace(/\D/g, "");
  // ITU E.164 and international phone number guidelines (typically 7 to 16 digits)
  return digits.length >= 7 && digits.length <= 16;
};

export const getFormErrorMessage = (formik, name) => {
  return (
    isFormValid(formik, name) && (
      <small className="p-error text-xs">{formik.errors[name]}</small>
    )
  );
};

export const getUserName = (data) => {
  const arName = `${data.anamE1} ${data.anamE2} ${data.anamE3} ${data.anamE4}`;
  const enName = `${data.enamE1} ${data.enamE2} ${data.enamE3} ${data.enamE4}`;
  return { arName, enName };
};

export const isValidNationalId = (value) => {
  return isNumber(value) && value.toString().trim().length === 10;
};

const apartmentRealty = ["8", "9", "28", "31", "32", "33"];

const flatPrclType = [8, 9, 29, 28, 31, 32, 33];

export const isFlat = (parcelType) => {
  return flatPrclType.includes(Number(parcelType));
};
// export const isLand = (parcelType) => {
//   return !apartmentRealty.includes(`${parcelType}`);
// };

export const isLand = (landFlag) => {
  return landFlag?.toUpperCase() === "LAND";
};

export const print = (data) => {
  const linkSource = `data:application/pdf;base64,${data}`;
  const downloadLink = document.createElement("a");
  const fileName = "file.pdf";

  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  window.open(downloadLink, "_blank");
};

export const downloadLocalPDF = (url, name) => {
  const downloadLink = document.createElement("a");
  const fileName = `${name}.pdf`;
  downloadLink.href = url;
  downloadLink.download = fileName;
  window.open(downloadLink, "_blank");
};

export const printBytes = (reportName, byte) => {
  const file = new Blob([byte], { type: "application/pdf" });
  const fileURL = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = fileURL;
  let fileName = reportName;
  link.download = fileName;
  window.open(fileURL);
};

export const pdfPrepare = (data) => {
  const base64WithoutPrefix = data.substr(
    "data:application/pdf;base64,".length,
  );

  const bytes = window.atob(base64WithoutPrefix);
  let length = bytes.length;
  let out = new Uint8Array(length);

  while (length--) {
    out[length] = bytes.charCodeAt(length);
  }

  return new Blob([out], { type: "application/pdf" });
};

export const licenseStatus = (value, expired) => {
  const { t } = i18n;

  switch (value) {
    case "3":
      return t("licenseStatus.stopped");
    case "4":
      return t("licenseStatus.canceled");
    default:
      if (expired) {
        return t("licenseStatus.expired");
      } else {
        return t("licenseStatus.active");
      }
  }
};
export const replacer = function (key, value) {
  if (this[key] instanceof Date) {
    return moment(this[key]).format("YYYY-MM-DD");
  }

  return value;
};
const replacerObject = function (key, value) {
  if (this[key] instanceof Date) {
    return moment(this[key]).format("YYYY-MM-DD");
  }
  if (typeof value === "string" && value.startsWith("data:")) {
    return "";
  }

  return value;
};

const authoritiesDecider = (auth) => {
  const { t } = i18n;

  switch (auth?.toUpperCase()) {
    case "PETRA":
      return t("authorities.PETRA");
    case "JIC":
      return t("authorities.JIC");
    case "JVA":
      return t("authorities.JVA");
    case "MOMA":
      return t("authorities.MOMA");
    case "ASEZA":
      return t("authorities.ASEZA");
    case "GAM":
      return t("authorities.GAM");
    case "BOARDER":
      return t("authorities.BOARDER");
    case "URBANDEV":
      return t("authorities.URBANDEV");
    default:
      return t("authorities.followedByProperty");
  }
};

export const authDecider = ({ sourceCode, sourceDesc }) => {
  switch (sourceCode?.toUpperCase()) {
    case "GAM":
      return t("authorities.GAM");
    case "MUNI":
      return sourceDesc;
    case "AUTH":
      return authoritiesDecider(sourceDesc);
    default:
      return t("authorities.followedByProperty");
  }
};

export const agencyValidations = (data, options = {}) => {
  const errors = {};
  const { t } = i18n;
  if (Boolean(data.isCompanyAgent)) {
    if (!data.agentNationalId) {
      errors["agentNationalId"] = t("errors.required");
    } else if (
      data.agentsList &&
      data.agentsList.findIndex(
        (agent) => agent.agentNationalId === data.agentNationalId,
      ) > -1
    ) {
      errors["agentNationalId"] = t("errors.duplicateNumber");
    }
    if (!data.agentName) {
      errors["agentName"] = t("errors.required");
    }
    if (data.isJordanianAgentDeputy) {
      if (!data.deputyAgentNationalId) {
        errors["deputyAgentNationalId"] = t("errors.required");
      } else if (!isValidNationalId(data.deputyAgentNationalId)) {
        errors["deputyAgentNationalId"] = t("errors.nationalId10Digits");
      }
      if (!data.deputyAgentCardNo) {
        errors["deputyAgentCardNo"] = t("errors.required");
      }
    } else {
      if (!data.deputyAgentPersonalNumber) {
        errors["deputyAgentPersonalNumber"] = t("errors.required");
      } else if (
        data.deputyAgentPersonalNumber &&
        !isNumber(data.deputyAgentPersonalNumber)
      ) {
        errors["deputyAgentPersonalNumber"] = t("errors.numbersOnly", {
          name: t("realtySelling.agentPersonalNumber"),
        });
      }
    }
    if (!data.deputyAgentName) {
      errors["deputyAgentName"] = t("errors.required");
    }

    if (!data.deputyAgentEntityNum) {
      errors["deputyAgentEntityNum"] = t("errors.required");
    }
    if (!data.deputyAgentEntityName) {
      errors["deputyAgentEntityName"] = t("errors.required");
    }
    if (!data.deputyAgentDeputyNum) {
      errors["deputyAgentDeputyNum"] = t("errors.required");
    }
    if (!data.deputyAgentDeputyAttach) {
      errors["deputyAgentDeputyAttach"] = t("errors.required");
    }
    if (!data.deputyAgentDeputyDate) {
      errors["deputyAgentDeputyDate"] = t("errors.required");
    }
    if (!data.deputyAgentPhoneNum) {
      errors["deputyAgentPhoneNum"] = t("errors.required");
    } else if (!phoneNumValidation(data.deputyAgentPhoneNum)) {
      errors.deputyAgentPhoneNum = t("errors.invalidPhone");
    }

    if (!data.agencyNumber) {
      errors["agencyNumber"] = t("errors.required");
    }
    if (!data.agencyDate) {
      errors["agencyDate"] = t("errors.required");
    }
    if (!data.agencyPlace) {
      errors["agencyPlace"] = t("errors.required");
    }

    return errors;
  }
  if (data.isJordanianAgent && data.isInternalAgency) {
    if (!data.agentNationalId) {
      errors["agentNationalId"] = t("errors.required");
    } else if (!isValidNationalId(data.agentNationalId)) {
      errors["agentNationalId"] = t("errors.nationalId10Digits");
    } else if (
      data.agentsList &&
      data.agentsList.findIndex(
        (agent) => agent.agentNationalId === data.agentNationalId,
      ) > -1
    ) {
      errors["agentNationalId"] = t("errors.duplicateNumber");
    }
    if (data.isSoldierAdj && !data.hasIdCardAdj) {
      if (!data.soldireAttachmentAdj) {
        errors.soldireAttachmentAdj = t("errors.required");
      }
      if (!data.agentName) {
        errors["agentName"] = t("errors.required");
      }
    } else {
      if (!data.agentInfo?.anamE1) {
        errors["agentName"] = t("errors.required");
      }
    }
  } else {
    if (data.isInternalAgency) {
      if (!data.isJordanianAgent) {
        if (
          data.agentInfo?.full_name
            ? !data.agentInfo?.full_name
            : !data.agentInfo?.e_full_name
        ) {
          errors["agentName"] = t("errors.required");
        }
      }

      if (!data.agentPersonalNumber) {
        errors["agentPersonalNumber"] = t("errors.required");
      } else if (
        data.agentPersonalNumber &&
        !isNumber(data.agentPersonalNumber)
      ) {
        errors["agentPersonalNumber"] = t("errors.numbersOnly", {
          name: t("realtySelling.agentPersonalNumber"),
        });
      } else if (
        data.agentsList &&
        data.agentsList.findIndex(
          (agent) => agent.agentPersonalNumber === data.agentPersonalNumber,
        ) > -1
      ) {
        errors["agentPersonalNumber"] = t("errors.duplicateNumber");
      }
      if (options.withForeignIssuer) {
        if (!data.foreignIssuerPlace) {
          errors["foreignIssuerPlace"] = t("errors.required");
        }
        if (!data.foreignIssuerDate) {
          errors["foreignIssuerDate"] = t("errors.required");
        }
      }
    }
  }

  if (data.isJordanianClient && data.isInternalAgency) {
  } else {
    if (!data.clientPersonalNumber && data.isInternalAgency) {
      errors["clientPersonalNumber"] = t("errors.required");
    } else if (
      data.clientPersonalNumber &&
      !isNumber(data.clientPersonalNumber)
    ) {
      errors["clientPersonalNumber"] = t("errors.numbersOnly", {
        name: t("realtySelling.clientPersonalNumber"),
      });
    }
  }

  if (data.isInternalAgency) {
    if (!data.agencyNumber) {
      errors["agencyNumber"] = t("errors.required");
    } else if (data.agencyNumber && !isNumber(data.agencyNumber)) {
      errors["agencyNumber"] = t("errors.numbersOnly", {
        name: t("realtySelling.agencyNumber"),
      });
    }
    if (!data.agencyClientName) {
      errors["agencyClientName"] = t("errors.required");
    }

    if (options.nonCriminal) {
      if (!data.nonCriminalAdj) {
        errors.nonCriminalAdj = t("errors.required");
      }
      if (data.nonCriminalStatusAdj !== t("common.active")) {
        errors.nonCriminalStatusAdj = t("errors.addValidStatus");
      }
    }
  }

  if (!data.isInternalAgency) {
    if (!data.attachAgency) {
      errors["attachAgency"] = t("errors.required");
    }
    // if (!data.agentNationalId) {
    //   errors["agentNationalId"] = t("errors.required");
    // }

    if (data.isJordanianAgent) {
      if (!data.agentNationalId) {
        errors["agentNationalId"] = t("errors.required");
      } else if (!isValidNationalId(data.agentNationalId)) {
        errors["agentNationalId"] = t("errors.nationalId10Digits");
      } else if (
        data.agentsList &&
        data.agentsList.findIndex(
          (agent) => agent.agentNationalId === data.agentNationalId,
        ) > -1
      ) {
        errors["agentNationalId"] = t("errors.duplicateNumber");
      }
      if (data.isSoldierAdj && !data.hasIdCardAdj) {
        if (!data.soldireAttachmentAdj) {
          errors.soldireAttachmentAdj = t("errors.required");
        }
        if (!data.agentName) {
          errors["agentName"] = t("errors.required");
        }
      } else {
        if (!data.agentInfo?.anamE1) {
          errors["agentName"] = t("errors.required");
        }
      }
    } else {
      if (!data.isJordanianAgent) {
        if (
          data.agentInfo?.full_name
            ? !data.agentInfo?.full_name
            : !data.agentInfo?.e_full_name
        ) {
          errors["agentName"] = t("errors.required");
        }
      }
      if (!data.agentPersonalNumber) {
        errors["agentPersonalNumber"] = t("errors.required");
      } else if (
        data.agentPersonalNumber &&
        !isNumber(data.agentPersonalNumber)
      ) {
        errors["agentPersonalNumber"] = t("errors.numbersOnly", {
          name: t("realtySelling.agentPersonalNumber"),
        });
      } else if (
        data.agentsList &&
        data.agentsList.findIndex(
          (agent) => agent.agentPersonalNumber === data.agentPersonalNumber,
        ) > -1
      ) {
        errors["agentPersonalNumber"] = t("errors.duplicateNumber");
      }
      if (options.withForeignIssuer) {
        if (!data.foreignIssuerPlace) {
          errors["foreignIssuerPlace"] = t("errors.required");
        }
        if (!data.foreignIssuerDate) {
          errors["foreignIssuerDate"] = t("errors.required");
        }
      }
    }

    if (!data.agencyNumber) {
      errors["agencyNumber"] = t("errors.required");
    }
    if (!data.agencyDate) {
      errors["agencyDate"] = t("errors.required");
    }
    if (!data.agencyPlace) {
      errors["agencyPlace"] = t("errors.required");
    }
  }
  return errors;
};

export const guardianValidations = (
  data,
  rules = { isMortgage: false },
  withoutSalesAuthorization = false,
) => {
  const errors = {};
  const { t } = i18n;
  if (data.isJordanianGuardian) {
    if (!data.guardianNationalId) {
      errors["guardianNationalId"] = t("errors.required");
    } else if (!isValidNationalId(data.guardianNationalId)) {
      errors["guardianNationalId"] = t("errors.nationalId10Digits");
    }
    if (!data.guardianCardNo) {
      errors["guardianCardNo"] = t("errors.required");
    }
    if (!data.guardianInfo?.anamE1) {
      errors["guardianName"] = t("errors.required");
    }
  } else {
    if (!data.guardianPersonalNumber) {
      errors["guardianPersonalNumber"] = t("errors.required");
    } else if (!isNumber(data.guardianPersonalNumber)) {
      errors["guardianPersonalNumber"] = t("errors.numbersOnly", {
        name: t("realtySelling.guardianPersonalNumber"),
      });
    }

    if (
      data.guardianInfo?.full_name
        ? !data.guardianInfo?.full_name
        : !data.guardianInfo?.e_full_name
    ) {
      errors["guardianName"] = t("errors.required");
    }
  }

  if (data.isJordanianMinor) {
  } else {
    if (!data.minorPersonalNumber) {
      errors["minorPersonalNumber"] = t("errors.required");
    } else if (!isNumber(data.minorPersonalNumber)) {
      errors["minorPersonalNumber"] = t("errors.numbersOnly", {
        name: t("realtySelling.minorPersonalNumber"),
      });
    }
  }

  if (!data.guardianshipNumber) {
    errors["guardianshipNumber"] = t("errors.required");
  }
  if (!data.guardianshipDate) {
    errors["guardianshipDate"] = t("errors.required");
  }
  if (!data.guardianshipPlace) {
    errors["guardianshipPlace"] = t("errors.required");
  }
  if (!data.guardianshipAttachment) {
    errors["guardianshipAttachment"] = t("errors.required");
  }

  if (withoutSalesAuthorization) {
  } else {
    if (!data.salesAuthorizationNumber) {
      errors["salesAuthorizationNumber"] = t("errors.required");
    }
    // else if (!isNumber(data.salesAuthorizationNumber)) {
    //   errors["salesAuthorizationNumber"] = t("errors.numbersOnly", {
    //     name: t("realtySelling.salesAuthorizationNumber"),
    //   });
    // }

    if (!data.salesAuthorizationDate) {
      errors["salesAuthorizationDate"] = t("errors.required");
    }
    if (!data.salesAuthorizationPlace) {
      errors["salesAuthorizationPlace"] = t("errors.required");
    }

    if (!rules.isMortgage) {
      if (!data.salesAuthorizationAttachment) {
        errors["salesAuthorizationAttachment"] = t("errors.required");
      }
    } else {
      if (!data.mortgageAuthorizationAttachment) {
        errors["mortgageAuthorizationAttachment"] = t("errors.required");
      }
    }
  }

  return errors;
};
export const guardianValidationsNew = (
  data,
  rules = { isMortgage: false },
  withoutSalesAuthorization = false,
) => {
  const errors = {};
  const { t } = i18n;
  if (data.isJordanianGuardian) {
    if (!data.guardianNationalId) {
      errors["guardianNationalId"] = t("errors.required");
    } else if (!isValidNationalId(data.guardianNationalId)) {
      errors["guardianNationalId"] = t("errors.nationalId10Digits");
    } else if (!data.kinshipRelation) {
      errors["guardianNationalId"] = " ";
    } else if (data.kinshipRelation === "3" && data.adjective === 3) {
      errors["guardianNationalId"] = " ";
    } else if (data.kinshipRelation === "1" && data.adjective === 5) {
      errors["guardianNationalId"] = " ";
    }
    if (data.isSoldierAdj && !data.hasIdCardAdj) {
      if (!data.soldireAttachmentAdj) {
        errors.soldireAttachmentAdj = t("errors.required");
      }
      if (!data.guardianName) {
        errors["guardianName"] = t("errors.required");
      }
    } else {
      if (!data.guardianCardNo) {
        errors["guardianCardNo"] = t("errors.required");
      }
      const guardianName = data.guardianName || data.guardianInfo?.anamE1;
      if (!guardianName) {
        errors["guardianName"] = t("errors.required");
      }
    }
  } else {
    if (!data.guardianPersonalNumber) {
      errors["guardianPersonalNumber"] = t("errors.required");
    } else if (!isNumber(data.guardianPersonalNumber)) {
      errors["guardianPersonalNumber"] = t("errors.numbersOnly", {
        name: t("realtySelling.guardianPersonalNumber"),
      });
    }

    if (
      data.guardianInfo?.full_name
        ? !data.guardianInfo?.full_name
        : !data.guardianInfo?.e_full_name
    ) {
      errors["guardianName"] = t("errors.required");
    }
    if (rules.withForeignIssuer) {
      if (!data.foreignIssuerPlace) {
        errors["foreignIssuerPlace"] = t("errors.required");
      }
      if (!data.foreignIssuerDate) {
        errors["foreignIssuerDate"] = t("errors.required");
      }
    }
  }

  if (data.isJordanianMinor) {
  } else {
    if (!data.minorPersonalNumber) {
      errors["minorPersonalNumber"] = t("errors.required");
    } else if (!isNumber(data.minorPersonalNumber)) {
      errors["minorPersonalNumber"] = t("errors.numbersOnly", {
        name: t("realtySelling.minorPersonalNumber"),
      });
    }
  }
  return errors;
};

export const deputyValidations = (data, options = {}) => {
  const errors = {};
  const { t } = i18n;

  if (data.isJordanianDeputy) {
    if (!data.deputyNationalId) {
      errors["deputyNationalId"] = t("errors.required");
    } else if (!isValidNationalId(data.deputyNationalId)) {
      errors["deputyNationalId"] = t("errors.nationalId10Digits");
    }
    if (!data.deputyCardNo) {
      errors["deputyCardNo"] = t("errors.required");
    }
  } else {
    if (!data.deputyPersonalNumber) {
      errors["deputyPersonalNumber"] = t("errors.required");
    } else if (!isNumber(data.deputyPersonalNumber)) {
      errors["deputyPersonalNumber"] = t("errors.numbersOnly", {
        name: t("realtySelling.deputyPersonalNumber"),
      });
    }
    if (options.withForeignIssuer) {
      if (!data.foreignIssuerPlace) {
        errors["foreignIssuerPlace"] = t("errors.required");
      }
      if (!data.foreignIssuerDate) {
        errors["foreignIssuerDate"] = t("errors.required");
      }
    }
  }

  if (!Object.keys(data.deputyInfo).length) {
    errors["entityNum"] = " ";
  }
  if (!data.entityNum) {
    errors["entityNum"] = t("errors.required");
  }
  if (!data.entityName) {
    errors["entityName"] = t("errors.required");
  }
  if (!data.deputyNum && !options.legalAffairs) {
    errors["deputyNum"] = t("errors.required");
  }
  if (!data.deputyAttach) {
    errors["deputyAttach"] = t("errors.required");
  }
  if (
    !data.commercialRegisterWithDeputyName &&
    options.commercialRegisterWithDeputyName
  ) {
    errors["commercialRegisterWithDeputyName"] = t("errors.required");
  }
  if (!data.deputyDate && !options.legalAffairs) {
    errors["deputyDate"] = t("errors.required");
  }
  if (!data.phoneNum) {
    errors["phoneNum"] = t("errors.required");
  } else if (!phoneNumValidation(data.phoneNum)) {
    errors.phoneNum = t("errors.invalidPhone");
  }

  if (options.nonCriminal) {
    if (!data.nonCriminalAdj) {
      errors.nonCriminalAdj = t("errors.required");
    }
    if (data.nonCriminalStatusAdj !== t("common.active")) {
      errors.nonCriminalStatusAdj = t("errors.addValidStatus");
    }
  }

  return errors;
};

export const getRandomNumber = () => {
  return Math.floor(Math.random() * 9000000000) + 1000000000;
};
export const getRefernceNumber = (deptCode = 0, serviceCode = 0) => {
  return `${new Date().getFullYear()}${deptCode}${serviceCode}${getRandomNumber()}`;
};

export const prepareAttchmentObj = (name, fileValue, id = null) => {
  if (id) {
    return {
      name,
      file: {
        value: fileValue,
        personalInfo: { value: JSON.stringify({ id: id }) },
      },
    };
  } else {
    return { name, file: { value: fileValue } };
  }
};

export const getSellingDetailsForCamunda = (
  obj,
  refrenceNumber,
  serviceCode,
  serviceETitle,
  serviceTitle,
) => {
  let {
    taskId,
    processInstanceId,
    attachments,
    selectedShares,
    buyersDetails,
    deptorsDetails,
    creditorDetails,
    ...rest
  } = obj;
  const { propertyData } = rest;
  rest = {
    ...rest,
    status: "قيد الدراسة",
    refrenceNumber: refrenceNumber,
    serviceCode: serviceCode,
    serviceTitle: serviceTitle,
    taskType: { en: serviceETitle, ar: serviceTitle },
    Number: +propertyData.depT_CODE,
    created: moment().format(),
  };
  const newSelectedShares = JSON.parse(
    JSON.stringify(selectedShares, replacer),
  );
  const newBuyersDetails = JSON.parse(JSON.stringify(buyersDetails, replacer));
  const newDeptorsDetails = JSON.parse(
    JSON.stringify(deptorsDetails || [], replacer),
  );
  const newCreditorDetails = JSON.parse(
    JSON.stringify(creditorDetails || [], replacer),
  );

  const myAttch = [];
  // prepare attchements

  newSelectedShares?.forEach((share) => {
    if (share.adjective === 2) {
      if (!share.isInternalAgency) {
        myAttch.push({
          name: `attachAgency_${share.partyId || share.passport_no}`,
          file: {
            value: share.attachAgency,
            personalInfo: {
              value: JSON.stringify({
                id: share.partyId || share.passport_no,
                type: "s",
              }),
            },
          },
        });
        delete share.attachAgency;
        myAttch.push({
          name: `attachAgency2_${share.partyId || share.passport_no}`,
          file: {
            value: share.attachAgency2,
            personalInfo: {
              value: JSON.stringify({
                id: share.partyId || share.passport_no,
                type: "s",
              }),
            },
          },
        });
        delete share.attachAgency2;
      }
    } else if (share.adjective === 4) {
      myAttch.push({
        name: `deputyAttach_${share.partyId || share.passport_no}`,
        file: {
          value: share.deputyAttach,
          personalInfo: {
            value: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
          },
        },
      });
      delete share.deputyAttach;
    } else if (share.adjective === 3) {
      myAttch.push({
        name: `salesAuthorizationAttachment_${share.partyId || share.passport_no
          }`,
        file: {
          value: share.salesAuthorizationAttachment,
          personalInfo: {
            value: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
          },
        },
      });
      myAttch.push({
        name: `guardianshipAttachment_${share.partyId || share.passport_no}`,
        file: {
          value: share.guardianshipAttachment,
          personalInfo: {
            value: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
          },
        },
      });
      delete share.salesAuthorizationAttachment;
      delete share.guardianshipAttachment;
    }
  });
  newBuyersDetails?.forEach((buyer) => {
    if (buyer.isSoldier) {
      myAttch.push({
        name: `soldireAttachment_${buyer.nationalId}`,
        file: {
          value: buyer.soldireAttachment,
          personalInfo: {
            value: JSON.stringify({ id: buyer.nationalId, type: "b" }),
          },
        },
      });
      delete buyer.soldireAttachment;
    }
    if (buyer.adjective === 2) {
      myAttch.push({
        name: `attachAgency_${buyer.nationalId}`,
        file: {
          value: buyer.attachAgency,
          personalInfo: {
            value: JSON.stringify({ id: buyer.nationalId, type: "b" }),
          },
        },
      });
      delete buyer.attachAgency;
      myAttch.push({
        name: `attachAgency2_${buyer.nationalId}`,
        file: {
          value: buyer.attachAgency2,
          personalInfo: {
            value: JSON.stringify({ id: buyer.nationalId, type: "b" }),
          },
        },
      });
      delete buyer.attachAgency2;
    } else if (buyer.adjective === 4) {
      myAttch.push({
        name: `deputyAttach_${buyer.nationalId}`,
        file: {
          value: buyer.deputyAttach,
          personalInfo: {
            value: JSON.stringify({ id: buyer.nationalId, type: "b" }),
          },
        },
      });
      delete buyer.deputyAttach;
    } else if (buyer.adjective === 3) {
      myAttch.push({
        name: `salesAuthorizationAttachment_${buyer.nationalId}`,
        file: {
          value: buyer.salesAuthorizationAttachment,
          personalInfo: {
            value: JSON.stringify({ id: buyer.nationalId, type: "b" }),
          },
        },
      });
      myAttch.push({
        name: `guardianshipAttachment_${buyer.nationalId}`,
        file: {
          value: buyer.guardianshipAttachment,
          personalInfo: {
            value: JSON.stringify({ id: buyer.nationalId, type: "b" }),
          },
        },
      });
      delete buyer.salesAuthorizationAttachment;
      delete buyer.guardianshipAttachment;
    }

    if (buyer.commercialRegisterRegistrationCertificate) {
      myAttch.push({
        name: `commercialRegisterRegistrationCertificate_${buyer.nationalId}`,
        file: {
          value: buyer.commercialRegisterRegistrationCertificate,
          personalInfo: {
            value: JSON.stringify({ id: buyer.nationalId, type: "b" }),
          },
        },
      });
      delete buyer.commercialRegisterRegistrationCertificate;
    }
  });

  newDeptorsDetails?.forEach((deptor) => {
    if (deptor.isSoldier) {
      myAttch.push({
        name: `soldireAttachment_deptor_${deptor.nationalId}`,
        file: {
          value: deptor.soldireAttachment,
          personalInfo: {
            value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
          },
        },
      });
      delete deptor.soldireAttachment;
    }
    if (deptor.adjective === 2) {
      myAttch.push({
        name: `attachAgency_deptor_${deptor.nationalId}`,
        file: {
          value: deptor.attachAgency,
          personalInfo: {
            value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
          },
        },
      });
      delete deptor.attachAgency;
      myAttch.push({
        name: `attachAgency2_deptor_${deptor.nationalId}`,
        file: {
          value: deptor.attachAgency2,
          personalInfo: {
            value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
          },
        },
      });
      delete deptor.attachAgency2;
    } else if (deptor.adjective === 4) {
      myAttch.push({
        name: `deputyAttach_deptor_${deptor.nationalId}`,
        file: {
          value: deptor.deputyAttach,
          personalInfo: {
            value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
          },
        },
      });
      delete deptor.deputyAttach;
    } else if (deptor.adjective === 3) {
      myAttch.push({
        name: `mortgageAuthorizationAttachment_deptor_${deptor.nationalId}`,
        file: {
          value: deptor.mortgageAuthorizationAttachment,
          personalInfo: {
            value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
          },
        },
      });
      myAttch.push({
        name: `guardianshipAttachment_deptor_${deptor.nationalId}`,
        file: {
          value: deptor.guardianshipAttachment,
          personalInfo: {
            value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
          },
        },
      });
      delete deptor.mortgageAuthorizationAttachment;
      delete deptor.guardianshipAttachment;
    }

    if (deptor.passport) {
      myAttch.push({
        name: `passport_deptor_${deptor.nationalId}`,
        file: {
          value: deptor.passport,
          personalInfo: { value: JSON.stringify({ id: deptor.nationalId }) },
        },
      });
      delete deptor.passport;
    }
    if (deptor.commercialRegisterRegistrationCertificate) {
      myAttch.push({
        name: `commercialRegisterRegistrationCertificate_deptor_${deptor.nationalId}`,
        file: {
          value: deptor.commercialRegisterRegistrationCertificate,
          personalInfo: {
            value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
          },
        },
      });
      delete deptor.commercialRegisterRegistrationCertificate;
    }
  });
  newCreditorDetails?.forEach((creditor) => {
    if (creditor.isSoldier) {
      myAttch.push({
        name: `soldireAttachment_creditor_${creditor.nationalId}`,
        file: {
          value: creditor.soldireAttachment,
          personalInfo: {
            value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
          },
        },
      });
      delete creditor.soldireAttachment;
    }
    if (creditor.adjective === 2) {
      myAttch.push({
        name: `attachAgency_creditor_${creditor.nationalId}`,
        file: {
          value: creditor.attachAgency,
          personalInfo: {
            value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
          },
        },
      });
      delete creditor.attachAgency;
      myAttch.push({
        name: `attachAgency2_creditor_${creditor.nationalId}`,
        file: {
          value: creditor.attachAgency2,
          personalInfo: {
            value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
          },
        },
      });
      delete creditor.attachAgency2;
    } else if (creditor.adjective === 4) {
      myAttch.push({
        name: `deputyAttach_creditor_${creditor.nationalId}`,
        file: {
          value: creditor.deputyAttach,
          personalInfo: {
            value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
          },
        },
      });
      delete creditor.deputyAttach;
    } else if (creditor.adjective === 3) {
      myAttch.push({
        name: `mortgageAuthorizationAttachment_creditor_${creditor.nationalId}`,
        file: {
          value: creditor.mortgageAuthorizationAttachment,
          personalInfo: {
            value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
          },
        },
      });
      myAttch.push({
        name: `guardianshipAttachment_creditor_${creditor.nationalId}`,
        file: {
          value: creditor.guardianshipAttachment,
          personalInfo: {
            value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
          },
        },
      });
      delete creditor.mortgageAuthorizationAttachment;
      delete creditor.guardianshipAttachment;
    }

    if (creditor.passport) {
      myAttch.push({
        name: `passport_creditor_${creditor.nationalId}`,
        file: {
          value: creditor.passport,
          personalInfo: { value: JSON.stringify({ id: creditor.nationalId }) },
        },
      });
      delete creditor.passport;
    }

    if (creditor.commercialRegisterRegistrationCertificate) {
      myAttch.push({
        name: `commercialRegisterRegistrationCertificate_creditor_${creditor.nationalId}`,
        file: {
          value: creditor.commercialRegisterRegistrationCertificate,
          personalInfo: {
            value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
          },
        },
      });
      delete creditor.commercialRegisterRegistrationCertificate;
    }
  });

  if (rest.clearanceAttachment) {
    myAttch.push({
      name: "clearanceAttachment",
      file: { value: rest.clearanceAttachment },
    });
    delete rest.clearanceAttachment;
  }
  if (rest.acknowledgmentExcuseDoc) {
    myAttch.push({
      name: "acknowledgmentExcuseDoc",
      file: { value: rest.acknowledgmentExcuseDoc },
    });
    delete rest.acknowledgmentExcuseDoc;
  }

  if (rest.hodClearance) {
    myAttch.push({ name: "hodClearance", file: { value: rest.hodClearance } });
    delete rest.hodClearance;
  }

  attachments?.forEach((file) => {
    myAttch.push({
      name: file.key,
      file: { value: file.file },
    });
  });

  return {
    id: taskId,
    processInstanceId: processInstanceId,
    regNumber: propertyData.reG_NO,
    status: "قيد الدراسة",
    refrenceNumber: refrenceNumber,
    serviceCode: serviceCode,
    serviceTitle: serviceTitle,
    attachments: myAttch,
    // "nationalId": userInfo.nationalId,
    Number: +propertyData.depT_CODE,
    message: getSubmittedMessage({
      serviceTitle: serviceTitle,
      refrenceNumber,
    }),
    notificationEmail: getSubmittedEmail({
      serviceTitle: serviceTitle,
      refrenceNumber,
    }),
    // attachments,
    variables: {
      object: {
        value: JSON.stringify(
          {
            ...rest,
            selectedShares: newSelectedShares,
            buyersDetails: newBuyersDetails,
            deptorsDetails: newDeptorsDetails,
            creditorDetails: newCreditorDetails,
          },
          replacerObject,
        ),
        type: "Json",
      },
      Number: { value: propertyData.depT_CODE },
      regNO: { value: propertyData.reG_NO },
    },
    withVariablesInReturn: true,
    created: moment().format(),
  };
};

export const getAttchmentObject = ({
  isNewCamunda,
  name,
  personalInfoValue,
  file,
  displayName = "",
}) => {
  let result = { name: name, file: {} };
  let personalInfo = {};
  if (personalInfoValue) {
    personalInfo.value = personalInfoValue;
  }

  if (isNewCamunda) {
    result.file = null;
    result.key = name;
    result.arrachmentStr = file;
  } else {
    result.file.value = file;
    if (personalInfoValue) {
      result.file.personalInfo = personalInfo;
    }
  }

  return result;
};

export const getSellingDetailsForCamundaNew = (
  obj,
  refrenceNumber,
  serviceCode,
  serviceETitle,
  serviceTitle,
  checkReligion = false,
  options = {
    extraVariables: {},
    newCamunda: false,
  },
) => {
  let {
    taskId,
    processInstanceId,
    attachments,
    selectedShares,
    buyersDetails,
    deptorsDetails,
    creditorDetails,
    ...rest
  } = obj;
  const { propertyData } = rest;
  rest = {
    ...rest,
    status: "قيد الدراسة",
    refrenceNumber: refrenceNumber,
    serviceCode: serviceCode,
    serviceTitle: serviceTitle,
    taskType: { en: serviceETitle, ar: serviceTitle },
    Number: +propertyData.depT_CODE,
    created: moment().format(),
    ...options.extraVariables,
  };
  const newSelectedShares = JSON.parse(
    JSON.stringify(selectedShares, replacer),
  );
  const newBuyersDetails = JSON.parse(JSON.stringify(buyersDetails, replacer));
  const newDeptorsDetails = JSON.parse(
    JSON.stringify(deptorsDetails || [], replacer),
  );
  const newCreditorDetails = JSON.parse(
    JSON.stringify(creditorDetails || [], replacer),
  );

  const myAttch = [];
  // prepare attchements

  newSelectedShares?.forEach((share) => {
    if (share.adjective === 2) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `soldireAttachmentAdj_${share.partyId || share.passport_no}`,
          personalInfoValue: JSON.stringify({
            id: share.partyId || share.passport_no,
            type: "s",
          }),
          file: share.soldireAttachmentAdj,
          displayName: "soldireAttachmentAdj",
        }),
      );
      delete share.soldireAttachmentAdj;

      if (share.agentCommercialRegisterRegistrationCertificate) {
        myAttch.push(
          getAttchmentObject({
            isNewCamunda: options.newCamunda,
            name: `agentCommercialRegisterRegistrationCertificate_${share.partyId || share.passport_no
              }`,
            personalInfoValue: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
            file: share.agentCommercialRegisterRegistrationCertificate,
            displayName: "agentCommercialRegisterRegistrationCertificate",
          }),
        );
        delete share.agentCommercialRegisterRegistrationCertificate;
      }
      if (share.deputyAgentDeputyAttach) {
        myAttch.push(
          getAttchmentObject({
            isNewCamunda: options.newCamunda,
            name: `deputyAgentDeputyAttach_${share.partyId || share.passport_no
              }`,
            personalInfoValue: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
            file: share.deputyAgentDeputyAttach,
            displayName: "deputyAgentDeputyAttach",
          }),
        );
        delete share.deputyAgentDeputyAttach;
      }

      if (share.agentsList && share.agentsList.length) {
        share.agentsList.forEach((item) => {
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: options.newCamunda,
              name: `soldireAttachmentAdj_${share.partyId || share.passport_no
                }_${item.agentNationalId || item.agentPersonalNumber}`,
              personalInfoValue: JSON.stringify({
                id: share.partyId || share.passport_no,
                type: "s",
              }),
              file: item.soldireAttachmentAdj,
              displayName: "soldireAttachmentAdj",
            }),
          );
          delete item.soldireAttachmentAdj;

          if (item.agentCommercialRegisterRegistrationCertificate) {
            myAttch.push(
              getAttchmentObject({
                isNewCamunda: options.newCamunda,
                name: `agentCommercialRegisterRegistrationCertificate_${share.partyId || share.passport_no
                  }_${item.agentNationalId || item.agentPersonalNumber}`,
                personalInfoValue: JSON.stringify({
                  id: share.partyId || share.passport_no,
                  type: "s",
                }),
                file: item.agentCommercialRegisterRegistrationCertificate,
                displayName: "agentCommercialRegisterRegistrationCertificate",
              }),
            );
            delete item.agentCommercialRegisterRegistrationCertificate;
          }
          if (item.deputyAgentDeputyAttach) {
            myAttch.push(
              getAttchmentObject({
                isNewCamunda: options.newCamunda,
                name: `deputyAgentDeputyAttach_${share.partyId || share.passport_no
                  }_${item.agentNationalId || item.agentPersonalNumber}`,
                personalInfoValue: JSON.stringify({
                  id: share.partyId || share.passport_no,
                  type: "s",
                }),
                file: item.deputyAgentDeputyAttach,
                displayName: "deputyAgentDeputyAttach",
              }),
            );
            delete item.deputyAgentDeputyAttach;
          }
        });
      }
      if (!share.isInternalAgency) {
        myAttch.push(
          getAttchmentObject({
            isNewCamunda: options.newCamunda,
            name: `attachAgency_${share.partyId || share.passport_no}`,
            personalInfoValue: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
            file: share.attachAgency,
            displayName: "attachAgency",
          }),
        );
        delete share.attachAgency;
        myAttch.push(
          getAttchmentObject({
            isNewCamunda: options.newCamunda,
            name: `attachAgency2_${share.partyId || share.passport_no}`,
            personalInfoValue: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
            file: share.attachAgency2,
            displayName: "attachAgency2",
          }),
        );
        delete share.attachAgency2;
      }
    } else if (share.adjective === 4) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `deputyAttach_${share.partyId || share.passport_no}`,
          personalInfoValue: JSON.stringify({
            id: share.partyId || share.passport_no,
            type: "s",
          }),
          file: share.deputyAttach,
          displayName: "deputyAttach",
        }),
      );
      delete share.deputyAttach;
    } else if (share.adjective === 3 || share.adjective === 5) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `soldireAttachmentAdj_${share.partyId || share.passport_no}`,
          personalInfoValue: JSON.stringify({
            id: share.partyId || share.passport_no,
            type: "s",
          }),
          file: share.soldireAttachmentAdj,
          displayName: "soldireAttachmentAdj",
        }),
      );
      delete share.soldireAttachmentAdj;

      share.selectedArguments?.forEach((item) => {
        if (+item.mainArgumentTypeCode === 4) {
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: options.newCamunda,
              name: `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode
                }_${share.partyId || share.passport_no}`,
              personalInfoValue: JSON.stringify({
                id: share.partyId || share.passport_no,
                type: "s",
              }),
              file: share[
                `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
              ],
              displayName: "salesAuthorizationAttachment",
            }),
          );
          delete share[
            `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          ];
        }
      });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `guardianshipAttachment_${share.partyId || share.passport_no}`,
          personalInfoValue: JSON.stringify({
            id: share.partyId || share.passport_no,
            type: "s",
          }),
          file: share.guardianshipAttachment,
          displayName: "guardianshipAttachment",
        }),
      );
      delete share.guardianshipAttachment;
    }
  });
  newBuyersDetails?.forEach((buyer) => {
    if (buyer.isSoldier) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `soldireAttachment_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.soldireAttachment,
          displayName: "soldireAttachment",
        }),
      );
      delete buyer.soldireAttachment;
    }
    if (buyer.adjective === 2) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `attachAgency_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.attachAgency,
          displayName: "attachAgency",
        }),
      );
      delete buyer.attachAgency;
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `attachAgency2_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.attachAgency2,
          displayName: "attachAgency2",
        }),
      );
      delete buyer.attachAgency2;

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `soldireAttachmentAdj_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.soldireAttachmentAdj,
          displayName: "soldireAttachmentAdj",
        }),
      );
      delete buyer.soldireAttachmentAdj;

      if (buyer.agentCommercialRegisterRegistrationCertificate) {
        myAttch.push(
          getAttchmentObject({
            isNewCamunda: options.newCamunda,
            name: `agentCommercialRegisterRegistrationCertificate_${buyer.nationalId}`,
            personalInfoValue: JSON.stringify({
              id: buyer.nationalId,
              type: "b",
            }),
            file: buyer.agentCommercialRegisterRegistrationCertificate,
            displayName: "agentCommercialRegisterRegistrationCertificate",
          }),
        );
        delete buyer.agentCommercialRegisterRegistrationCertificate;
      }
      if (buyer.deputyAgentDeputyAttach) {
        myAttch.push(
          getAttchmentObject({
            isNewCamunda: options.newCamunda,
            name: `deputyAgentDeputyAttach_${buyer.nationalId}`,
            personalInfoValue: JSON.stringify({
              id: buyer.nationalId,
              type: "b",
            }),
            file: buyer.deputyAgentDeputyAttach,
            displayName: "deputyAgentDeputyAttach",
          }),
        );
        delete buyer.deputyAgentDeputyAttach;
      }

      if (buyer.agentsList && buyer.agentsList.length) {
        buyer.agentsList.forEach((item) => {
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: options.newCamunda,
              name: `soldireAttachmentAdj_${buyer.nationalId}_${item.agentNationalId || item.agentPersonalNumber
                }`,
              personalInfoValue: JSON.stringify({
                id: buyer.nationalId,
                type: "b",
              }),
              file: item.soldireAttachmentAdj,
              displayName: "soldireAttachmentAdj",
            }),
          );
          delete item.soldireAttachmentAdj;

          if (item.agentCommercialRegisterRegistrationCertificate) {
            myAttch.push(
              getAttchmentObject({
                isNewCamunda: options.newCamunda,
                name: `agentCommercialRegisterRegistrationCertificate_${buyer.nationalId
                  }_${item.agentNationalId || item.agentPersonalNumber}`,
                personalInfoValue: JSON.stringify({
                  id: buyer.nationalId,
                  type: "b",
                }),
                file: item.agentCommercialRegisterRegistrationCertificate,
                displayName: "agentCommercialRegisterRegistrationCertificate",
              }),
            );
            delete item.agentCommercialRegisterRegistrationCertificate;
          }
          if (item.deputyAgentDeputyAttach) {
            myAttch.push(
              getAttchmentObject({
                isNewCamunda: options.newCamunda,
                name: `deputyAgentDeputyAttach_${buyer.nationalId}_${item.agentNationalId || item.agentPersonalNumber
                  }`,
                personalInfoValue: JSON.stringify({
                  id: buyer.nationalId,
                  type: "b",
                }),
                file: item.deputyAgentDeputyAttach,
                displayName: "deputyAgentDeputyAttach",
              }),
            );
            delete item.deputyAgentDeputyAttach;
          }
        });
      }
    } else if (buyer.adjective === 4) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `deputyAttach_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.deputyAttach,
          displayName: "deputyAttach",
        }),
      );
      delete buyer.deputyAttach;
    } else if (buyer.adjective === 3 || buyer.adjective === 5) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `soldireAttachmentAdj_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.soldireAttachmentAdj,
          displayName: "soldireAttachmentAdj",
        }),
      );
      delete buyer.soldireAttachmentAdj;

      buyer.selectedArguments?.forEach((item) => {
        if (+item.mainArgumentTypeCode === 4) {
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: options.newCamunda,
              name: `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}_${buyer.nationalId}`,
              personalInfoValue: JSON.stringify({
                id: buyer.nationalId,
                type: "b",
              }),
              file: buyer[
                `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
              ],
              displayName: "salesAuthorizationAttachment",
            }),
          );
          delete buyer[
            `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          ];
        }
      });

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `guardianshipAttachment_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.guardianshipAttachment,
          displayName: "guardianshipAttachment",
        }),
      );
      delete buyer.guardianshipAttachment;
    }

    if (buyer.commercialRegisterRegistrationCertificate) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `commercialRegisterRegistrationCertificate_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.commercialRegisterRegistrationCertificate,
          displayName: "commercialRegisterRegistrationCertificate",
        }),
      );
      delete buyer.commercialRegisterRegistrationCertificate;
    }

    if (buyer.investmentApprovalAttach) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `investmentApprovalAttach_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.investmentApprovalAttach,
          displayName: "investmentApprovalAttach",
        }),
      );
      delete buyer.investmentApprovalAttach;
    }
  });

  newDeptorsDetails?.forEach((deptor) => {
    if (deptor.isSoldier) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `soldireAttachment_deptor_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.soldireAttachment,
          displayName: "soldireAttachment",
        }),
      );
      delete deptor.soldireAttachment;
    }
    if (deptor.adjective === 2) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `attachAgency_deptor_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.attachAgency,
          displayName: "attachAgency",
        }),
      );
      delete deptor.attachAgency;
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `attachAgency2_deptor_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.attachAgency2,
          displayName: "attachAgency2",
        }),
      );
      delete deptor.attachAgency2;
    } else if (deptor.adjective === 4) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `deputyAttach_deptor_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.deputyAttach,
          displayName: "deputyAttach",
        }),
      );
      delete deptor.deputyAttach;
    } else if (deptor.adjective === 3 || deptor.adjective === 5) {
      deptor.selectedArguments?.forEach((item) => {
        if (+item.mainArgumentTypeCode === 4) {
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: options.newCamunda,
              name: `mortgageAuthorizationAttachment_${item.secondaryArgumentTypeCode}_deptor_${deptor.nationalId}`,
              personalInfoValue: JSON.stringify({
                id: deptor.nationalId,
                type: "b",
              }),
              file: deptor[
                `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
              ],
              displayName: "mortgageAuthorizationAttachment",
            }),
          );
          delete deptor[
            `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          ];
        }
      });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `guardianshipAttachment_deptor_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.guardianshipAttachment,
          displayName: "guardianshipAttachment",
        }),
      );
      delete deptor.guardianshipAttachment;
    }

    if (deptor.passport) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `passport_deptor_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({ id: deptor.nationalId }),
          file: deptor.passport,
          displayName: "passport",
        }),
      );
      delete deptor.passport;
    }
    if (deptor.commercialRegisterRegistrationCertificate) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `commercialRegisterRegistrationCertificate_deptor_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.commercialRegisterRegistrationCertificate,
          displayName: "commercialRegisterRegistrationCertificate",
        }),
      );
      delete deptor.commercialRegisterRegistrationCertificate;
    }
  });
  newCreditorDetails?.forEach((creditor) => {
    if (creditor.isSoldier) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `soldireAttachment_creditor_${creditor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.soldireAttachment,
          displayName: "soldireAttachment",
        }),
      );
      delete creditor.soldireAttachment;
    }
    if (creditor.adjective === 2) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `attachAgency_creditor_${creditor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.attachAgency,
          displayName: "attachAgency",
        }),
      );
      delete creditor.attachAgency;
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `attachAgency2_creditor_${creditor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.attachAgency2,
          displayName: "attachAgency2",
        }),
      );
      delete creditor.attachAgency2;
    } else if (creditor.adjective === 4) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `deputyAttach_creditor_${creditor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.deputyAttach,
          displayName: "deputyAttach",
        }),
      );
      delete creditor.deputyAttach;
    } else if (creditor.adjective === 3 || creditor.adjective === 5) {
      creditor.selectedArguments?.forEach((item) => {
        if (+item.mainArgumentTypeCode === 4) {
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: options.newCamunda,
              name: `mortgageAuthorizationAttachment_${item.secondaryArgumentTypeCode}_creditor_${creditor.nationalId}`,
              personalInfoValue: JSON.stringify({
                id: creditor.nationalId,
                type: "b",
              }),
              file: creditor[
                `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
              ],
              displayName: "mortgageAuthorizationAttachment",
            }),
          );
          delete creditor[
            `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          ];
        }
      });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `guardianshipAttachment_creditor_${creditor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.guardianshipAttachment,
          displayName: "guardianshipAttachment",
        }),
      );
      delete creditor.guardianshipAttachment;
    }

    if (creditor.passport) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `passport_creditor_${creditor.nationalId}`,
          personalInfoValue: JSON.stringify({ id: creditor.nationalId }),
          file: creditor.passport,
          displayName: "passport",
        }),
      );
      delete creditor.passport;
    }

    if (creditor.commercialRegisterRegistrationCertificate) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: options.newCamunda,
          name: `commercialRegisterRegistrationCertificate_creditor_${creditor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.commercialRegisterRegistrationCertificate,
          displayName: "commercialRegisterRegistrationCertificate",
        }),
      );
      delete creditor.commercialRegisterRegistrationCertificate;
    }
  });

  if (rest.clearanceAttachment) {
    myAttch.push(
      getAttchmentObject({
        isNewCamunda: options.newCamunda,
        name: "clearanceAttachment",
        file: rest.clearanceAttachment,
        displayName: "clearanceAttachment",
      }),
    );
    delete rest.clearanceAttachment;
  }
  if (rest.acknowledgmentExcuseDoc) {
    myAttch.push(
      getAttchmentObject({
        isNewCamunda: options.newCamunda,
        name: "acknowledgmentExcuseDoc",
        file: rest.acknowledgmentExcuseDoc,
        displayName: "acknowledgmentExcuseDoc",
      }),
    );
    delete rest.acknowledgmentExcuseDoc;
  }

  if (rest.hodClearance) {
    myAttch.push(
      getAttchmentObject({
        isNewCamunda: options.newCamunda,
        name: "hodClearance",
        file: rest.hodClearance,
        displayName: "hodClearance",
      }),
    );
    delete rest.hodClearance;
  }

  attachments?.forEach((file) => {
    myAttch.push(
      getAttchmentObject({
        isNewCamunda: options.newCamunda,
        name: file.key,
        file: file.file,
        displayName: file.name,
      }),
    );
  });

  let isThereMuslim = false;

  if (checkReligion) {
    isThereMuslim = checkIfThereAreMuslims({
      selectedShares: newSelectedShares,
      buyersDetails: newBuyersDetails,
      deptorsDetails: newDeptorsDetails,
      creditorDetails: newCreditorDetails,
    });
  }

  const convertedExtraVariables = {};

  if (options.extraVariables) {
    Object.keys(options.extraVariables).forEach((key) => {
      if (
        key !== "status" &&
        typeof options.extraVariables[key] !== "undefined"
      ) {
        convertedExtraVariables[key] = {
          value: `${options.extraVariables[key]}`,
        };
      }
    });
  }

  const oldAttachments = {};
  if (options.newCamunda) {
    myAttch.forEach((item) => {
      oldAttachments[item.name] = item.oldStructure;
    });
  }

  const maplstAttachmentsToVariables = {};
  if (options.newCamunda) {
    if (myAttch && myAttch.length) {
      myAttch.forEach((item) => {
        let base64 = (item.arrachmentStr || item.attachmentStr)
          ?.replace(/"/g, "")
          .trim();

        if (base64) {
          maplstAttachmentsToVariables[item.key] = {
            type: "Json",
            value: JSON.stringify({
              value: base64,
            }),
          };
        }
      });
    }
  }

  return {
    id: taskId,
    processInstanceId: processInstanceId,
    regNumber: propertyData.reG_NO,
    status: "قيد الدراسة",
    refrenceNumber: refrenceNumber,
    serviceCode: serviceCode,
    serviceTitle: serviceTitle,
    attachments: options.newCamunda
      ? myAttch.filter((item) => item.arrachmentStr)
      : myAttch,
    // "nationalId": userInfo.nationalId,
    Number: +propertyData.depT_CODE,
    SendtoDCJ: isThereMuslim,
    message: getSubmittedMessage({
      serviceTitle: serviceTitle,
      refrenceNumber,
    }),
    notificationEmail: getSubmittedEmail({
      serviceTitle: serviceTitle,
      refrenceNumber,
    }),
    ...options.extraVariables,
    variables: {
      object: {
        value: JSON.stringify(
          {
            ...rest,
            selectedShares: newSelectedShares,
            buyersDetails: newBuyersDetails,
            deptorsDetails: newDeptorsDetails,
            creditorDetails: newCreditorDetails,
          },
          replacerObject,
        ),
        type: "Json",
      },
      Number: { value: propertyData.depT_CODE },
      SendtoDCJ: { value: `${isThereMuslim}` },
      regNO: { value: propertyData.reG_NO },
      ...convertedExtraVariables,
      // ...maplstAttachmentsToVariables,
    },
    withVariablesInReturn: true,
    created: moment().format(),
  };
};

// const realtyNeedsNoClearance = [
//   "0",
//   "3",
//   "4",
//   "5",
//   "6",
//   "7",
//   "16",
//   "17",
//   "18",
//   "19",
//   "23",
//   "26",
//   "27",
//   "35",
//   "36",
// ];
const realtyNeedsNoClearance = ["34"];

export const realtyNeedsClearanceCheck = (parcelType) =>
  !realtyNeedsNoClearance.includes(parcelType);

const OwnershipTransferAttachments = ({ objForAttachment }, serviceCode) => {
  let {
    taskId,
    processInstanceId,
    attachments,
    selectedShares,
    buyersDetails,
    buyerSellersMapper,
    endowmentDoc,
    clearanceAttachment,
    noObjectionDoc,
    exchangedProperty,
    applicantInfo,
    rentalsDetails,
    deptorsDetails,
    creditorDetails,
    applicantDetails,
    propertiesDetails,
    detectionResultAttach,
    fieldMonitoringForm,
    fieldMonitoringFormPdf,
    referencePointsAttach,
    ...rest
  } = objForAttachment;

  // prepare attchements
  const myAttch = [];

  selectedShares?.forEach((share) => {
    if (share.adjective === 2) {
      if (!share.isInternalAgency) {
        myAttch.push({
          name: `attachAgency_${share.partyId || share.passport_no}`,
          file: {
            value: share.attachAgency,
            personalInfo: {
              value: JSON.stringify({
                id: share.partyId || share.passport_no,
                type: "s",
              }),
            },
          },
        });
        delete share.attachAgency;
        myAttch.push({
          name: `attachAgency2_${share.partyId || share.passport_no}`,
          file: {
            value: share.attachAgency2,
            personalInfo: {
              value: JSON.stringify({
                id: share.partyId || share.passport_no,
                type: "s",
              }),
            },
          },
        });
        delete share.attachAgency2;
      }
    } else if (share.adjective === 4) {
      myAttch.push({
        name: `deputyAttach_${share.partyId || share.passport_no}`,
        file: {
          value: share.deputyAttach,
          personalInfo: {
            value: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
          },
        },
      });
      delete share.deputyAttach;
    } else if (share.adjective === 3) {
      myAttch.push({
        name: `salesAuthorizationAttachment_${share.partyId || share.passport_no
          }`,
        file: {
          value: share.salesAuthorizationAttachment,
          personalInfo: {
            value: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
          },
        },
      });
      myAttch.push({
        name: `guardianshipAttachment_${share.partyId || share.passport_no}`,
        file: {
          value: share.guardianshipAttachment,
          personalInfo: {
            value: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
          },
        },
      });
      delete share.salesAuthorizationAttachment;
      delete share.guardianshipAttachment;
    }
    if (share.deathCert) {
      delete share.deathCert;
    }
  });

  if (exchangedProperty && exchangedProperty[0]) {
    if (exchangedProperty[0].clearanceAttachment) {
      myAttch.push({
        name: `clearanceAttachment_exchange`,
        file: {
          value: exchangedProperty[0].clearanceAttachment,
          personalInfo: {
            value: JSON.stringify({
              id: "exchange",
              type: "s",
            }),
          },
        },
      });
      delete exchangedProperty[0].clearanceAttachment;
    }
    if (exchangedProperty[0].hodClearance) {
      myAttch.push({
        name: `hodClearance_exchange`,
        file: {
          value: exchangedProperty[0].hodClearance,
          personalInfo: {
            value: JSON.stringify({
              id: "exchange",
              type: "s",
            }),
          },
        },
      });
      delete exchangedProperty[0].hodClearance;
    }
    exchangedProperty[0].selectedShares?.forEach((share) => {
      if (share.adjective === 2) {
        if (!share.isInternalAgency) {
          myAttch.push({
            name: `attachAgency_exchange_${share.partyId || share.passport_no}`,
            file: {
              value: share.attachAgency,
              personalInfo: {
                value: JSON.stringify({
                  id: share.partyId || share.passport_no,
                  type: "s",
                }),
              },
            },
          });
          delete share.attachAgency;
          myAttch.push({
            name: `attachAgency2_exchange_${share.partyId || share.passport_no
              }`,
            file: {
              value: share.attachAgency2,
              personalInfo: {
                value: JSON.stringify({
                  id: share.partyId || share.passport_no,
                  type: "s",
                }),
              },
            },
          });
          delete share.attachAgency2;
        }
      } else if (share.adjective === 4) {
        myAttch.push({
          name: `deputyAttach_exchange_${share.partyId || share.passport_no}`,
          file: {
            value: share.deputyAttach,
            personalInfo: {
              value: JSON.stringify({
                id: share.partyId || share.passport_no,
                type: "s",
              }),
            },
          },
        });
        delete share.deputyAttach;
      } else if (share.adjective === 3) {
        myAttch.push({
          name: `salesAuthorizationAttachment_exchange_${share.partyId || share.passport_no
            }`,
          file: {
            value: share.salesAuthorizationAttachment,
            personalInfo: {
              value: JSON.stringify({
                id: share.partyId || share.passport_no,
                type: "s",
              }),
            },
          },
        });
        myAttch.push({
          name: `guardianshipAttachment_exchange_${share.partyId || share.passport_no
            }`,
          file: {
            value: share.guardianshipAttachment,
            personalInfo: {
              value: JSON.stringify({
                id: share.partyId || share.passport_no,
                type: "s",
              }),
            },
          },
        });
        delete share.salesAuthorizationAttachment;
        delete share.guardianshipAttachment;
      }
      if (share.deathCert) {
        delete share.deathCert;
      }
    });
  }

  buyerSellersMapper?.forEach((share) => {
    if (share.seller?.deathCert) {
      myAttch.push({
        name: "deathCert",
        file: {
          value: share.seller.deathCert,
          personalInfo: {
            value: JSON.stringify({ id: share.seller.partyId, type: "s" }),
          },
        },
      });
      delete share.seller.deathCert;
    }
    if (share.seller?.deputyAttach) {
      delete share.seller.deputyAttach;
    }
    if (share.buyer?.deputyAttach) {
      delete share.buyer.deputyAttach;
    }
    if (share.buyer?.commercialRegisterRegistrationCertificate) {
      delete share.buyer.commercialRegisterRegistrationCertificate;
    }
  });

  if (applicantInfo) {
    let id = "";
    if (Object.keys(applicantInfo.citizenInformation || {}).length) {
      id = applicantInfo.citizenInformation.naT_NO;
    }

    if (Object.keys(applicantInfo.companyInformation || {}).length) {
      id = applicantInfo.companyInformation.compid;
    }
    if (applicantInfo.isSoldier) {
      myAttch.push({
        name: `soldireAttachment_${applicantInfo.nationalId}`,
        file: {
          value: applicantInfo.soldireAttachment,
          personalInfo: {
            value: JSON.stringify({ id: applicantInfo.nationalId, type: "b" }),
          },
        },
      });
      delete applicantInfo.soldireAttachment;
    }

    if (applicantInfo.adjective === 2) {
      myAttch.push({
        name: `attachAgency_${id}`,
        file: {
          value: applicantInfo.attachAgency,
          personalInfo: {
            value: JSON.stringify({ id: id, type: "b" }),
          },
        },
      });
      delete applicantInfo.attachAgency;
      myAttch.push({
        name: `attachAgency2_${id}`,
        file: {
          value: applicantInfo.attachAgency2,
          personalInfo: {
            value: JSON.stringify({ id: id, type: "b" }),
          },
        },
      });
      delete applicantInfo.attachAgency2;
    } else if (applicantInfo.adjective === 4) {
      myAttch.push({
        name: `deputyAttach_${id}`,
        file: {
          value: applicantInfo.deputyAttach,
          personalInfo: {
            value: JSON.stringify({ id: id, type: "b" }),
          },
        },
      });
      delete applicantInfo.deputyAttach;
    } else if (applicantInfo.adjective === 3) {
      myAttch.push({
        name: `salesAuthorizationAttachment_${id}`,
        file: {
          value: applicantInfo.salesAuthorizationAttachment,
          personalInfo: {
            value: JSON.stringify({ id: id, type: "b" }),
          },
        },
      });
      myAttch.push({
        name: `guardianshipAttachment_${id}`,
        file: {
          value: applicantInfo.guardianshipAttachment,
          personalInfo: {
            value: JSON.stringify({ id: id, type: "b" }),
          },
        },
      });
      delete applicantInfo.salesAuthorizationAttachment;
      delete applicantInfo.guardianshipAttachment;
    }

    if (applicantInfo.passport) {
      myAttch.push({
        name: `passport_${id}`,
        file: {
          value: applicantInfo.passport,
          personalInfo: { value: JSON.stringify({ id: id }) },
        },
      });
      delete applicantInfo.passport;
    }

    if (applicantInfo.commercialRegisterRegistrationCertificate) {
      myAttch.push({
        name: `commercialRegisterRegistrationCertificate_${id}`,
        file: {
          value: applicantInfo.commercialRegisterRegistrationCertificate,
          personalInfo: {
            value: JSON.stringify({ id: id, type: "b" }),
          },
        },
      });
      delete applicantInfo.commercialRegisterRegistrationCertificate;
    }
  }

  propertiesDetails?.forEach((property) => {
    if (property.clearanceAttachment) {
      myAttch.push({
        name: `clearanceAttachment_${property.pRandom}`,
        file: { value: property.clearanceAttachment },
      });
      delete property.clearanceAttachment;
    }
  });
  buyersDetails?.forEach((buyer, i) => {
    if (buyer.isSoldier) {
      myAttch.push({
        name: `soldireAttachment_${buyer.nationalId}`,
        file: {
          value: buyer.soldireAttachment,
          personalInfo: {
            value: JSON.stringify({ id: buyer.nationalId, type: "b" }),
          },
        },
      });
      delete buyer.soldireAttachment;
    }
    if (buyer.adjective === 2) {
      myAttch.push({
        name: `attachAgency_${buyer.nationalId}`,
        file: {
          value: buyer.attachAgency,
          personalInfo: {
            value: JSON.stringify({ id: buyer.nationalId, type: "b" }),
          },
        },
      });
      delete buyer.attachAgency;
      myAttch.push({
        name: `attachAgency2_${buyer.nationalId}`,
        file: {
          value: buyer.attachAgency2,
          personalInfo: {
            value: JSON.stringify({ id: buyer.nationalId, type: "b" }),
          },
        },
      });
      delete buyer.attachAgency2;
    } else if (buyer.adjective === 4) {
      myAttch.push({
        name: `deputyAttach_${buyer.nationalId}`,
        file: {
          value: buyer.deputyAttach,
          personalInfo: {
            value: JSON.stringify({ id: buyer.nationalId, type: "b" }),
          },
        },
      });
      delete buyer.deputyAttach;
    } else if (buyer.adjective === 3) {
      myAttch.push({
        name: `salesAuthorizationAttachment_${buyer.nationalId}`,
        file: {
          value: buyer.salesAuthorizationAttachment,
          personalInfo: {
            value: JSON.stringify({ id: buyer.nationalId, type: "b" }),
          },
        },
      });
      myAttch.push({
        name: `guardianshipAttachment_${buyer.nationalId}`,
        file: {
          value: buyer.guardianshipAttachment,
          personalInfo: {
            value: JSON.stringify({ id: buyer.nationalId, type: "b" }),
          },
        },
      });
      delete buyer.salesAuthorizationAttachment;
      delete buyer.guardianshipAttachment;
    }

    if (buyer.passport) {
      myAttch.push({
        name: `passport_${buyer.nationalId}`,
        file: {
          value: buyer.passport,
          personalInfo: { value: JSON.stringify({ id: buyer.nationalId }) },
        },
      });
      delete buyer.passport;
    }

    if (buyer.commercialRegisterRegistrationCertificate) {
      myAttch.push({
        name: `commercialRegisterRegistrationCertificate_${buyer.nationalId}`,
        file: {
          value: buyer.commercialRegisterRegistrationCertificate,
          personalInfo: {
            value: JSON.stringify({ id: buyer.nationalId, type: "b" }),
          },
        },
      });
      delete buyer.commercialRegisterRegistrationCertificate;
    }

    // if (buyer.deputyAttach) {
    //   myAttch.push({ name: `deputyAttach_${buyer.nationalId}`, file: { value: buyer.deputyAttach, personalInfo: { value: JSON.stringify({ "id": buyer.nationalId }) } } })
    //   delete buyersDetails[i].buyer.deputyAttach
    // }
  });
  rentalsDetails?.forEach((rental, i) => {
    if (rental.isSoldier) {
      myAttch.push({
        name: `soldireAttachment_rental_${rental.nationalId}`,
        file: {
          value: rental.soldireAttachment,
          personalInfo: {
            value: JSON.stringify({ id: rental.nationalId, type: "b" }),
          },
        },
      });
      delete rental.soldireAttachment;
    }
    if (rental.adjective === 2) {
      myAttch.push({
        name: `attachAgency_rental_${rental.nationalId}`,
        file: {
          value: rental.attachAgency,
          personalInfo: {
            value: JSON.stringify({ id: rental.nationalId, type: "b" }),
          },
        },
      });
      delete rental.attachAgency;
      myAttch.push({
        name: `attachAgency2_rental_${rental.nationalId}`,
        file: {
          value: rental.attachAgency2,
          personalInfo: {
            value: JSON.stringify({ id: rental.nationalId, type: "b" }),
          },
        },
      });
      delete rental.attachAgency2;
    } else if (rental.adjective === 4) {
      myAttch.push({
        name: `deputyAttach_rental_${rental.nationalId}`,
        file: {
          value: rental.deputyAttach,
          personalInfo: {
            value: JSON.stringify({ id: rental.nationalId, type: "b" }),
          },
        },
      });
      delete rental.deputyAttach;
    } else if (rental.adjective === 3) {
      myAttch.push({
        name: `salesAuthorizationAttachment_rental_${rental.nationalId}`,
        file: {
          value: rental.salesAuthorizationAttachment,
          personalInfo: {
            value: JSON.stringify({ id: rental.nationalId, type: "b" }),
          },
        },
      });
      myAttch.push({
        name: `guardianshipAttachment_rental_${rental.nationalId}`,
        file: {
          value: rental.guardianshipAttachment,
          personalInfo: {
            value: JSON.stringify({ id: rental.nationalId, type: "b" }),
          },
        },
      });
      delete rental.salesAuthorizationAttachment;
      delete rental.guardianshipAttachment;
    }

    if (rental.passport) {
      myAttch.push({
        name: `passport_rental_${rental.nationalId}`,
        file: {
          value: rental.passport,
          personalInfo: { value: JSON.stringify({ id: rental.nationalId }) },
        },
      });
      delete rental.passport;
    }

    if (rental.commercialRegisterRegistrationCertificate) {
      myAttch.push({
        name: `commercialRegisterRegistrationCertificate_rental_${rental.nationalId}`,
        file: {
          value: rental.commercialRegisterRegistrationCertificate,
          personalInfo: {
            value: JSON.stringify({ id: rental.nationalId, type: "b" }),
          },
        },
      });
      delete rental.commercialRegisterRegistrationCertificate;
    }

    // if (buyer.deputyAttach) {
    //   myAttch.push({ name: `deputyAttach_${buyer.nationalId}`, file: { value: buyer.deputyAttach, personalInfo: { value: JSON.stringify({ "id": buyer.nationalId }) } } })
    //   delete buyersDetails[i].buyer.deputyAttach
    // }
  });

  deptorsDetails?.forEach((deptor) => {
    if (deptor.isSoldier) {
      myAttch.push({
        name: `soldireAttachment_deptor_${deptor.nationalId}`,
        file: {
          value: deptor.soldireAttachment,
          personalInfo: {
            value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
          },
        },
      });
      delete deptor.soldireAttachment;
    }
    if (deptor.adjective === 2) {
      myAttch.push({
        name: `attachAgency_deptor_${deptor.nationalId}`,
        file: {
          value: deptor.attachAgency,
          personalInfo: {
            value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
          },
        },
      });
      delete deptor.attachAgency;
      myAttch.push({
        name: `attachAgency2_deptor_${deptor.nationalId}`,
        file: {
          value: deptor.attachAgency2,
          personalInfo: {
            value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
          },
        },
      });
      delete deptor.attachAgency2;
    } else if (deptor.adjective === 4) {
      myAttch.push({
        name: `deputyAttach_deptor_${deptor.nationalId}`,
        file: {
          value: deptor.deputyAttach,
          personalInfo: {
            value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
          },
        },
      });
      delete deptor.deputyAttach;
    } else if (deptor.adjective === 3) {
      myAttch.push({
        name: `mortgageAuthorizationAttachment_deptor_${deptor.nationalId}`,
        file: {
          value: deptor.mortgageAuthorizationAttachment,
          personalInfo: {
            value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
          },
        },
      });
      myAttch.push({
        name: `guardianshipAttachment_deptor_${deptor.nationalId}`,
        file: {
          value: deptor.guardianshipAttachment,
          personalInfo: {
            value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
          },
        },
      });
      delete deptor.salesAuthorizationAttachment;
      delete deptor.guardianshipAttachment;
    }

    if (deptor.passport) {
      myAttch.push({
        name: `passport_deptor_${deptor.nationalId}`,
        file: {
          value: deptor.passport,
          personalInfo: { value: JSON.stringify({ id: deptor.nationalId }) },
        },
      });
      delete deptor.passport;
    }

    if (deptor.commercialRegisterRegistrationCertificate) {
      myAttch.push({
        name: `commercialRegisterRegistrationCertificate_deptor_${deptor.nationalId}`,
        file: {
          value: deptor.commercialRegisterRegistrationCertificate,
          personalInfo: {
            value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
          },
        },
      });
      delete deptor.commercialRegisterRegistrationCertificate;
    }
  });
  creditorDetails?.forEach((creditor) => {
    if (creditor.isSoldier) {
      myAttch.push({
        name: `soldireAttachment_creditor_${creditor.nationalId}`,
        file: {
          value: creditor.soldireAttachment,
          personalInfo: {
            value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
          },
        },
      });
      delete creditor.soldireAttachment;
    }
    if (creditor.adjective === 2) {
      myAttch.push({
        name: `attachAgency_creditor_${creditor.nationalId}`,
        file: {
          value: creditor.attachAgency,
          personalInfo: {
            value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
          },
        },
      });
      delete creditor.attachAgency;
      myAttch.push({
        name: `attachAgency2_creditor_${creditor.nationalId}`,
        file: {
          value: creditor.attachAgency2,
          personalInfo: {
            value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
          },
        },
      });
      delete creditor.attachAgency2;
    } else if (creditor.adjective === 4) {
      myAttch.push({
        name: `deputyAttach_creditor_${creditor.nationalId}`,
        file: {
          value: creditor.deputyAttach,
          personalInfo: {
            value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
          },
        },
      });
      delete creditor.deputyAttach;
    } else if (creditor.adjective === 3) {
      myAttch.push({
        name: `mortgageAuthorizationAttachment_creditor_${creditor.nationalId}`,
        file: {
          value: creditor.mortgageAuthorizationAttachment,
          personalInfo: {
            value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
          },
        },
      });
      myAttch.push({
        name: `guardianshipAttachment_creditor_${creditor.nationalId}`,
        file: {
          value: creditor.guardianshipAttachment,
          personalInfo: {
            value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
          },
        },
      });
      delete creditor.salesAuthorizationAttachment;
      delete creditor.guardianshipAttachment;
    }

    if (creditor.passport) {
      myAttch.push({
        name: `passport_creditor_${creditor.nationalId}`,
        file: {
          value: creditor.passport,
          personalInfo: { value: JSON.stringify({ id: creditor.nationalId }) },
        },
      });
      delete creditor.passport;
    }

    if (creditor.commercialRegisterRegistrationCertificate) {
      myAttch.push({
        name: `commercialRegisterRegistrationCertificate_creditor_${creditor.nationalId}`,
        file: {
          value: creditor.commercialRegisterRegistrationCertificate,
          personalInfo: {
            value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
          },
        },
      });
      delete creditor.commercialRegisterRegistrationCertificate;
    }
  });
  applicantDetails?.forEach((applicant) => {
    if (applicant.isSoldier) {
      myAttch.push({
        name: `soldireAttachment_applicant_${applicant.nationalId}`,
        file: {
          value: applicant.soldireAttachment,
          personalInfo: {
            value: JSON.stringify({ id: applicant.nationalId, type: "b" }),
          },
        },
      });
      delete applicant.soldireAttachment;
    }
    if (applicant.adjective === 2) {
      myAttch.push({
        name: `attachAgency_applicant_${applicant.nationalId}`,
        file: {
          value: applicant.attachAgency,
          personalInfo: {
            value: JSON.stringify({ id: applicant.nationalId, type: "b" }),
          },
        },
      });
      delete applicant.attachAgency;
      myAttch.push({
        name: `attachAgency2_applicant_${applicant.nationalId}`,
        file: {
          value: applicant.attachAgency2,
          personalInfo: {
            value: JSON.stringify({ id: applicant.nationalId, type: "b" }),
          },
        },
      });
      delete applicant.attachAgency2;
    } else if (applicant.adjective === 4) {
      myAttch.push({
        name: `deputyAttach_applicant_${applicant.nationalId}`,
        file: {
          value: applicant.deputyAttach,
          personalInfo: {
            value: JSON.stringify({ id: applicant.nationalId, type: "b" }),
          },
        },
      });
      delete applicant.deputyAttach;
    } else if (applicant.adjective === 3) {
      myAttch.push({
        name: `mortgageAuthorizationAttachment_applicant_${applicant.nationalId}`,
        file: {
          value: applicant.mortgageAuthorizationAttachment,
          personalInfo: {
            value: JSON.stringify({ id: applicant.nationalId, type: "b" }),
          },
        },
      });
      myAttch.push({
        name: `guardianshipAttachment_applicant_${applicant.nationalId}`,
        file: {
          value: applicant.guardianshipAttachment,
          personalInfo: {
            value: JSON.stringify({ id: applicant.nationalId, type: "b" }),
          },
        },
      });
      delete applicant.salesAuthorizationAttachment;
      delete applicant.guardianshipAttachment;
    }

    if (applicant.passport) {
      myAttch.push({
        name: `passport_applicant_${applicant.nationalId}`,
        file: {
          value: applicant.passport,
          personalInfo: { value: JSON.stringify({ id: applicant.nationalId }) },
        },
      });
      delete applicant.passport;
    }

    if (applicant.commercialRegisterRegistrationCertificate) {
      myAttch.push({
        name: `commercialRegisterRegistrationCertificate_applicant_${applicant.nationalId}`,
        file: {
          value: applicant.commercialRegisterRegistrationCertificate,
          personalInfo: {
            value: JSON.stringify({ id: applicant.nationalId, type: "b" }),
          },
        },
      });
      delete applicant.commercialRegisterRegistrationCertificate;
    }
  });

  if (clearanceAttachment) {
    myAttch.push({
      name: "clearanceAttachment",
      file: { value: clearanceAttachment },
    });
    delete objForAttachment.clearanceAttachment;
  }
  if (rest.acknowledgmentExcuseDoc) {
    myAttch.push({
      name: "acknowledgmentExcuseDoc",
      file: { value: rest.acknowledgmentExcuseDoc },
    });
    delete objForAttachment.acknowledgmentExcuseDoc;
  }
  if (Object.keys(detectionResultAttach || {}).length) {
    for (const key in detectionResultAttach) {
      myAttch.push({
        name: `detectionResultAttach_${key}`,
        file: { value: detectionResultAttach[key] },
      });
    }
    delete objForAttachment.detectionResultAttach;
  }
  if (Object.keys(fieldMonitoringForm || {}).length) {
    for (const key in fieldMonitoringForm) {
      myAttch.push({
        name: `fieldMonitoringForm_${key}`,
        file: { value: fieldMonitoringForm[key] },
      });
    }
    delete objForAttachment.fieldMonitoringForm;
  }
  if (Object.keys(fieldMonitoringFormPdf || {}).length) {
    for (const key in fieldMonitoringFormPdf) {
      myAttch.push({
        name: `fieldMonitoringFormPdf_${key}`,
        file: { value: fieldMonitoringFormPdf[key] },
      });
    }
    delete objForAttachment.fieldMonitoringFormPdf;
  }
  if (Object.keys(referencePointsAttach || {}).length) {
    for (const key in referencePointsAttach) {
      myAttch.push({
        name: `referencePointsAttach_${key}`,
        file: { value: referencePointsAttach[key] },
      });
    }
    delete objForAttachment.referencePointsAttach;
  }

  if (noObjectionDoc) {
    myAttch.push({ name: "noObjectionDoc", file: { value: noObjectionDoc } });
    delete objForAttachment.noObjectionDoc;
  }

  if (objForAttachment.inheritanceDoc) {
    myAttch.push({
      name: "deathCert",
      file: { value: objForAttachment.inheritanceDoc },
    });
    delete objForAttachment.inheritanceDoc;
  }

  if (objForAttachment.takharogDoc) {
    myAttch.push({
      name: "deathCert",
      file: { value: objForAttachment.takharogDoc },
    });
    delete objForAttachment.takharogDoc;
  }

  if (objForAttachment.correctionDoc) {
    myAttch.push({
      name: "deathCert",
      file: { value: objForAttachment.correctionDoc },
    });
    delete objForAttachment.correctionDoc;
  }

  if (endowmentDoc) {
    myAttch.push({ name: "endowmentDoc", file: { value: endowmentDoc } });
    delete objForAttachment.endowmentDoc;
  }

  if (objForAttachment.clearanceAttachment) {
    myAttch.push({
      name: "clearanceAttachment",
      file: { value: objForAttachment.clearanceAttachment },
    });
    delete objForAttachment.clearanceAttachment;
  }

  if (objForAttachment.hodClearance) {
    myAttch.push({
      name: "hodClearance",
      file: { value: objForAttachment.hodClearance },
    });
    delete objForAttachment.hodClearance;
  }

  if (["DLS4013", "DLS4012"].includes(serviceCode)) {
    Object.keys(attachments).forEach((key) => {
      attachments[key].forEach((file) => {
        myAttch.push({
          name: `${file.key}_${key}`,
          file: { value: file.file },
        });
      });
    });
  } else {
    attachments?.forEach((file) => {
      myAttch.push({
        name: file.key,
        file: { value: file.file },
      });
    });
  }

  return myAttch;
};
const OwnershipTransferAttachmentsNew = (
  { objForAttachment },
  serviceCode,
  newCamunda = false,
) => {
  let {
    taskId,
    processInstanceId,
    attachments,
    selectedShares,
    buyersDetails,
    buyerSellersMapper,
    endowmentDoc,
    clearanceAttachment,
    noObjectionDoc,
    exchangedProperty,
    applicantInfo,
    rentalsDetails,
    deptorsDetails,
    creditorDetails,
    applicantDetails,
    propertiesDetails,
    detectionResultAttach,
    fieldMonitoringForm,
    referencePointsAttach,
    deceasedAgent,
    fieldMonitoringFormPdf,
    ...rest
  } = objForAttachment;

  // prepare attchements
  const myAttch = [];

  selectedShares?.forEach((share) => {
    if (share.adjective === 2) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `soldireAttachmentAdj_${share.partyId || share.passport_no}`,
          personalInfoValue: JSON.stringify({
            id: share.partyId || share.passport_no,
            type: "s",
          }),
          file: share.soldireAttachmentAdj,
          displayName: "soldireAttachmentAdj",
        }),
      );
      delete share.soldireAttachmentAdj;

      if (!share.isInternalAgency) {
        myAttch.push(
          getAttchmentObject({
            isNewCamunda: newCamunda,
            name: `attachAgency_${share.partyId || share.passport_no}`,
            personalInfoValue: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
            file: share.attachAgency,
            displayName: "attachAgency",
          }),
        );

        delete share.attachAgency;

        myAttch.push(
          getAttchmentObject({
            isNewCamunda: newCamunda,
            name: `attachAgency2_${share.partyId || share.passport_no}`,
            personalInfoValue: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
            file: share.attachAgency2,
            displayName: "attachAgency2",
          }),
        );

        delete share.attachAgency2;
      }
    } else if (share.adjective === 4) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `deputyAttach_${share.partyId || share.passport_no}`,
          personalInfoValue: JSON.stringify({
            id: share.partyId || share.passport_no,
            type: "s",
          }),
          file: share.deputyAttach,
          displayName: "deputyAttach",
        }),
      );

      delete share.deputyAttach;
    } else if (share.adjective === 3 || share.adjective === 5) {
      share.selectedArguments?.forEach((item) => {
        if (+item.mainArgumentTypeCode === 4) {
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: newCamunda,
              name: `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}_${share.partyId || share.passport_no}`,
              personalInfoValue: JSON.stringify({
                id: share.partyId || share.passport_no,
                type: "s",
              }),
              file: share[
                `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
              ],
              displayName: "salesAuthorizationAttachment",
            }),
          );

          delete share[
            `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          ];
        }
      });

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `guardianshipAttachment_${share.partyId || share.passport_no}`,
          personalInfoValue: JSON.stringify({
            id: share.partyId || share.passport_no,
            type: "s",
          }),
          file: share.guardianshipAttachment,
          displayName: "guardianshipAttachment",
        }),
      );

      delete share.guardianshipAttachment;
    }
    if (share.deathCert) {
      delete share.deathCert;
    }
  });

  if (exchangedProperty && exchangedProperty[0]) {
    if (exchangedProperty[0].clearanceAttachment) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `clearanceAttachment_exchange`,
          personalInfoValue: JSON.stringify({
            id: "exchange",
            type: "s",
          }),
          file: exchangedProperty[0].clearanceAttachment,
          displayName: "clearanceAttachment",
        }),
      );
      delete exchangedProperty[0].clearanceAttachment;
    }
    if (exchangedProperty[0].hodClearance) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `hodClearance_exchange`,
          personalInfoValue: JSON.stringify({
            id: "exchange",
            type: "s",
          }),
          file: exchangedProperty[0].hodClearance,
          displayName: "hodClearance",
        }),
      );
      delete exchangedProperty[0].hodClearance;
    }
    exchangedProperty[0].selectedShares?.forEach((share) => {
      if (share.adjective === 2) {
        myAttch.push(
          getAttchmentObject({
            isNewCamunda: newCamunda,
            name: `soldireAttachmentAdj_${share.partyId || share.passport_no}`,
            personalInfoValue: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
            file: share.soldireAttachmentAdj,
            displayName: "soldireAttachmentAdj",
          }),
        );

        delete share.soldireAttachmentAdj;

        if (!share.isInternalAgency) {
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: newCamunda,
              name: `attachAgency_exchange_${share.partyId || share.passport_no}`,
              personalInfoValue: JSON.stringify({
                id: share.partyId || share.passport_no,
                type: "s",
              }),
              file: share.attachAgency,
              displayName: "attachAgency",
            }),
          );

          delete share.attachAgency;

          myAttch.push(
            getAttchmentObject({
              isNewCamunda: newCamunda,
              name: `attachAgency2_exchange_${share.partyId || share.passport_no}`,
              personalInfoValue: JSON.stringify({
                id: share.partyId || share.passport_no,
                type: "s",
              }),
              file: share.attachAgency2,
              displayName: "attachAgency2",
            }),
          );

          delete share.attachAgency2;
        }
      } else if (share.adjective === 4) {
        myAttch.push(
          getAttchmentObject({
            isNewCamunda: newCamunda,
            name: `deputyAttach_exchange_${share.partyId || share.passport_no}`,
            personalInfoValue: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
            file: share.deputyAttach,
            displayName: "deputyAttach",
          }),
        );

        delete share.deputyAttach;
      } else if (share.adjective === 3 || share.adjective === 5) {
        share.selectedArguments?.forEach((item) => {
          if (+item.mainArgumentTypeCode === 4) {
            myAttch.push(
              getAttchmentObject({
                isNewCamunda: newCamunda,
                name: `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}_exchange_${share.partyId || share.passport_no}`,
                personalInfoValue: JSON.stringify({
                  id: share.partyId || share.passport_no,
                  type: "s",
                }),
                file: share[
                  `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
                ],
                displayName: "salesAuthorizationAttachment",
              }),
            );

            delete share[
              `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
            ];
          }
        });

        myAttch.push(
          getAttchmentObject({
            isNewCamunda: newCamunda,
            name: `guardianshipAttachment_exchange_${share.partyId || share.passport_no}`,
            personalInfoValue: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
            file: share.guardianshipAttachment,
            displayName: "guardianshipAttachment",
          }),
        );

        delete share.guardianshipAttachment;
      }
      if (share.deathCert) {
        delete share.deathCert;
      }
    });
  }

  buyerSellersMapper?.forEach((share) => {
    if (share.seller?.deathCert) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: "deathCert",
          personalInfoValue: JSON.stringify({
            id: share.seller.partyId,
            type: "s",
          }),
          file: share.seller.deathCert,
          displayName: "deathCert",
        }),
      );

      delete share.seller.deathCert;
    }
    if (share.seller?.deputyAttach) {
      delete share.seller.deputyAttach;
    }
    if (share.buyer?.deputyAttach) {
      delete share.buyer.deputyAttach;
    }
    if (share.buyer?.commercialRegisterRegistrationCertificate) {
      delete share.buyer.commercialRegisterRegistrationCertificate;
    }
  });

  if (applicantInfo) {
    let id = "";
    if (Object.keys(applicantInfo.citizenInformation || {}).length) {
      id = applicantInfo.citizenInformation.naT_NO;
    }

    if (Object.keys(applicantInfo.companyInformation || {}).length) {
      id = applicantInfo.companyInformation.compid;
    }
    if (applicantInfo.isSoldier) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `soldireAttachment_${applicantInfo.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: applicantInfo.nationalId,
            type: "b",
          }),
          file: applicantInfo.soldireAttachment,
          displayName: "soldireAttachment",
        }),
      );

      delete applicantInfo.soldireAttachment;
    }

    if (applicantInfo.adjective === 2) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `attachAgency_${id}`,
          personalInfoValue: JSON.stringify({ id: id, type: "b" }),
          file: applicantInfo.attachAgency,
          displayName: "attachAgency",
        }),
      );

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `attachAgency2_${id}`,
          personalInfoValue: JSON.stringify({ id: id, type: "b" }),
          file: applicantInfo.attachAgency2,
          displayName: "attachAgency2",
        }),
      );

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `soldireAttachmentAdj_${id}`,
          personalInfoValue: JSON.stringify({ id: id, type: "b" }),
          file: applicantInfo.soldireAttachmentAdj,
          displayName: "soldireAttachmentAdj",
        }),
      );

      delete applicantInfo.attachAgency;
      delete applicantInfo.attachAgency2;
      delete applicantInfo.soldireAttachmentAdj;
    } else if (applicantInfo.adjective === 4) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `deputyAttach_${id}`,
          personalInfoValue: JSON.stringify({ id: id, type: "b" }),
          file: applicantInfo.deputyAttach,
          displayName: "deputyAttach",
        }),
      );

      delete applicantInfo.deputyAttach;
    } else if (applicantInfo.adjective === 3 || applicantInfo.adjective === 5) {
      applicantInfo.selectedArguments?.forEach((item) => {
        if (+item.mainArgumentTypeCode === 4) {
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: newCamunda,
              name: `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}_${id}`,
              personalInfoValue: JSON.stringify({ id: id, type: "b" }),
              file: applicantInfo[
                `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
              ],
              displayName: "salesAuthorizationAttachment",
            }),
          );

          delete applicantInfo[
            `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          ];
        }
      });

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `guardianshipAttachment_${id}`,
          personalInfoValue: JSON.stringify({ id: id, type: "b" }),
          file: applicantInfo.guardianshipAttachment,
          displayName: "guardianshipAttachment",
        }),
      );

      delete applicantInfo.guardianshipAttachment;
    }

    if (applicantInfo.passport) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `passport_${id}`,
          personalInfoValue: JSON.stringify({ id: id }),
          file: applicantInfo.passport,
          displayName: "passport",
        }),
      );

      delete applicantInfo.passport;
    }

    if (applicantInfo.commercialRegisterRegistrationCertificate) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `commercialRegisterRegistrationCertificate_${id}`,
          personalInfoValue: JSON.stringify({ id: id, type: "b" }),
          file: applicantInfo.commercialRegisterRegistrationCertificate,
          displayName: "commercialRegisterRegistrationCertificate",
        }),
      );

      delete applicantInfo.commercialRegisterRegistrationCertificate;
    }
  }

  if (deceasedAgent) {
    if (deceasedAgent.isSoldier) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `soldireAttachment_${deceasedAgent.nationalId}_deceasedAgent`,
          personalInfoValue: JSON.stringify({
            id: deceasedAgent.nationalId,
            type: "b",
          }),
          file: deceasedAgent.soldireAttachment,
          displayName: "soldireAttachment",
        }),
      );

      delete deceasedAgent.soldireAttachment;

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `deathCertificate_${deceasedAgent.nationalId}_deceasedAgent`,
          personalInfoValue: JSON.stringify({
            id: deceasedAgent.nationalId,
            type: "b",
          }),
          file: deceasedAgent.deathCertificate,
          displayName: "deathCertificate",
        }),
      );

      delete deceasedAgent.deathCertificate;
    }
  }
  propertiesDetails?.forEach((property) => {
    if (property.clearanceAttachment) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `clearanceAttachment_${property.pRandom}`,
          personalInfoValue: JSON.stringify({
            id: property.pRandom,
            type: "s",
          }),
          file: property.clearanceAttachment,
          displayName: "clearanceAttachment",
        }),
      );

      delete property.clearanceAttachment;
    }
  });
  buyersDetails?.forEach((buyer, i) => {
    if (buyer.isSoldier) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `soldireAttachment_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.soldireAttachment,
          displayName: "soldireAttachment",
        }),
      );

      delete buyer.soldireAttachment;
    }
    if (buyer.investmentApprovalAttach) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `investmentApprovalAttach_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.investmentApprovalAttach,
          displayName: "investmentApprovalAttach",
        }),
      );

      delete buyer.investmentApprovalAttach;
    }

    if (buyer.adjective === 2) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `attachAgency_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.attachAgency,
          displayName: "attachAgency",
        }),
      );

      delete buyer.attachAgency;

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `attachAgency2_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.attachAgency2,
          displayName: "attachAgency2",
        }),
      );

      delete buyer.attachAgency2;

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `soldireAttachmentAdj_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.soldireAttachmentAdj,
          displayName: "soldireAttachmentAdj",
        }),
      );

      delete buyer.soldireAttachmentAdj;
    } else if (buyer.adjective === 4) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `deputyAttach_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.deputyAttach,
          displayName: "deputyAttach",
        }),
      );

      delete buyer.deputyAttach;
    } else if (buyer.adjective === 3 || buyer.adjective === 5) {
      buyer.selectedArguments?.forEach((item) => {
        if (+item.mainArgumentTypeCode === 4) {
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: newCamunda,
              name: `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}_${buyer.nationalId}`,
              personalInfoValue: JSON.stringify({
                id: buyer.nationalId,
                type: "b",
              }),
              file: buyer[
                `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
              ],
              displayName: "salesAuthorizationAttachment",
            }),
          );

          delete buyer[
            `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          ];
        }
      });

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `guardianshipAttachment_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.guardianshipAttachment,
          displayName: "guardianshipAttachment",
        }),
      );

      delete buyer.guardianshipAttachment;
    }

    if (buyer.passport) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `passport_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({ id: buyer.nationalId }),
          file: buyer.passport,
          displayName: "passport",
        }),
      );

      delete buyer.passport;
    }

    if (buyer.commercialRegisterRegistrationCertificate) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `commercialRegisterRegistrationCertificate_${buyer.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: buyer.nationalId,
            type: "b",
          }),
          file: buyer.commercialRegisterRegistrationCertificate,
          displayName: "commercialRegisterRegistrationCertificate",
        }),
      );

      delete buyer.commercialRegisterRegistrationCertificate;
    }

    // if (buyer.deputyAttach) {
    //   myAttch.push({ name: `deputyAttach_${buyer.nationalId}`, file: { value: buyer.deputyAttach, personalInfo: { value: JSON.stringify({ "id": buyer.nationalId }) } } })
    //   delete buyersDetails[i].buyer.deputyAttach
    // }
  });
  rentalsDetails?.forEach((rental, i) => {
    if (rental.isSoldier) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `soldireAttachment_rental_${rental.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: rental.nationalId,
            type: "b",
          }),
          file: rental.soldireAttachment,
          displayName: "soldireAttachment",
        }),
      );

      delete rental.soldireAttachment;
    }
    if (rental.adjective === 2) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `attachAgency_rental_${rental.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: rental.nationalId,
            type: "b",
          }),
          file: rental.attachAgency,
          displayName: "attachAgency",
        }),
      );

      delete rental.attachAgency;

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `attachAgency2_rental_${rental.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: rental.nationalId,
            type: "b",
          }),
          file: rental.attachAgency2,
          displayName: "attachAgency2",
        }),
      );

      delete rental.attachAgency2;
    } else if (rental.adjective === 4) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `deputyAttach_rental_${rental.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: rental.nationalId,
            type: "b",
          }),
          file: rental.deputyAttach,
          displayName: "deputyAttach",
        }),
      );

      delete rental.deputyAttach;
    } else if (rental.adjective === 3 || rental.adjective === 5) {
      rental.selectedArguments?.forEach((item) => {
        if (+item.mainArgumentTypeCode === 4) {
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: newCamunda,
              name: `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}_rental_${rental.nationalId}`,
              personalInfoValue: JSON.stringify({
                id: rental.nationalId,
                type: "b",
              }),
              file: rental[
                `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
              ],
              displayName: "salesAuthorizationAttachment",
            }),
          );
          delete rental[
            `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          ];
        }
      });

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `guardianshipAttachment_rental_${rental.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: rental.nationalId,
            type: "b",
          }),
          file: rental.guardianshipAttachment,
          displayName: "guardianshipAttachment",
        }),
      );

      delete rental.guardianshipAttachment;
    }

    if (rental.investmentApprovalAttach) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `investmentApprovalAttach_${rental.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: rental.nationalId,
            type: "b",
          }),
          file: rental.investmentApprovalAttach,
          displayName: "investmentApprovalAttach",
        }),
      );

      delete rental.investmentApprovalAttach;
    }

    if (rental.passport) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `passport_rental_${rental.nationalId}`,
          personalInfoValue: JSON.stringify({ id: rental.nationalId }),
          file: rental.passport,
          displayName: "passport",
        }),
      );

      delete rental.passport;
    }

    if (rental.commercialRegisterRegistrationCertificate) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `commercialRegisterRegistrationCertificate_rental_${rental.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: rental.nationalId,
            type: "b",
          }),
          file: rental.commercialRegisterRegistrationCertificate,
          displayName: "commercialRegisterRegistrationCertificate",
        }),
      );

      delete rental.commercialRegisterRegistrationCertificate;
    }

    // if (buyer.deputyAttach) {
    //   myAttch.push({ name: `deputyAttach_${buyer.nationalId}`, file: { value: buyer.deputyAttach, personalInfo: { value: JSON.stringify({ "id": buyer.nationalId }) } } })
    //   delete buyersDetails[i].buyer.deputyAttach
    // }
  });

  deptorsDetails?.forEach((deptor) => {
    if (deptor.isSoldier) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `soldireAttachment_deptor_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.soldireAttachment,
          displayName: "soldireAttachment",
        }),
      );

      delete deptor.soldireAttachment;
    }
    if (deptor.adjective === 2) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `attachAgency_deptor_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.attachAgency,
          displayName: "attachAgency",
        }),
      );

      delete deptor.attachAgency;

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `attachAgency2_deptor_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.attachAgency2,
          displayName: "attachAgency2",
        }),
      );

      delete deptor.attachAgency2;
    } else if (deptor.adjective === 4) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `deputyAttach_deptor_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.deputyAttach,
          displayName: "deputyAttach",
        }),
      );

      delete deptor.deputyAttach;
    } else if (deptor.adjective === 3 || deptor.adjective === 5) {
      deptor.selectedArguments?.forEach((item) => {
        if (+item.mainArgumentTypeCode === 4) {
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: newCamunda,
              name: `mortgageAuthorizationAttachment_${item.secondaryArgumentTypeCode}_deptor_${deptor.nationalId}`,
              personalInfoValue: JSON.stringify({
                id: deptor.nationalId,
                type: "b",
              }),
              file: deptor[
                `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
              ],
              displayName: "salesAuthorizationAttachment",
            }),
          );

          delete deptor[
            `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          ];
        }
      });

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `guardianshipAttachment_deptor_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.guardianshipAttachment,
          displayName: "guardianshipAttachment",
        }),
      );

      delete deptor.guardianshipAttachment;
    }

    if (deptor.passport) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `passport_deptor_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({ id: deptor.nationalId }),
          file: deptor.passport,
          displayName: "passport",
        }),
      );

      delete deptor.passport;
    }

    if (deptor.commercialRegisterRegistrationCertificate) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `commercialRegisterRegistrationCertificate_deptor_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.commercialRegisterRegistrationCertificate,
          displayName: "commercialRegisterRegistrationCertificate",
        }),
      );

      delete deptor.commercialRegisterRegistrationCertificate;
    }
  });
  creditorDetails?.forEach((creditor) => {
    if (creditor.isSoldier) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `soldireAttachment_creditor_${creditor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.soldireAttachment,
          displayName: "soldireAttachment",
        }),
      );

      delete creditor.soldireAttachment;
    }
    if (creditor.adjective === 2) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `attachAgency_creditor_${creditor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.attachAgency,
          displayName: "attachAgency",
        }),
      );

      delete creditor.attachAgency;

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `attachAgency2_creditor_${creditor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.attachAgency2,
          displayName: "attachAgency2",
        }),
      );

      delete creditor.attachAgency2;
    } else if (creditor.adjective === 4) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `deputyAttach_creditor_${creditor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.deputyAttach,
          displayName: "deputyAttach",
        }),
      );

      delete creditor.deputyAttach;
    } else if (creditor.adjective === 3 || creditor.adjective === 5) {
      creditor.selectedArguments?.forEach((item) => {
        if (+item.mainArgumentTypeCode === 4) {
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: newCamunda,
              name: `mortgageAuthorizationAttachment_${item.secondaryArgumentTypeCode}_creditor_${creditor.nationalId}`,
              personalInfoValue: JSON.stringify({
                id: creditor.nationalId,
                type: "b",
              }),
              file: creditor[
                `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
              ],
              displayName: "salesAuthorizationAttachment",
            }),
          );

          delete creditor[
            `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          ];
        }
      });

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `guardianshipAttachment_creditor_${creditor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.guardianshipAttachment,
          displayName: "guardianshipAttachment",
        }),
      );

      delete creditor.guardianshipAttachment;
    }

    if (creditor.passport) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `passport_creditor_${creditor.nationalId}`,
          personalInfoValue: JSON.stringify({ id: creditor.nationalId }),
          file: creditor.passport,
          displayName: "passport",
        }),
      );

      delete creditor.passport;
    }

    if (creditor.commercialRegisterRegistrationCertificate) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `commercialRegisterRegistrationCertificate_creditor_${creditor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.commercialRegisterRegistrationCertificate,
          displayName: "commercialRegisterRegistrationCertificate",
        }),
      );
      delete creditor.commercialRegisterRegistrationCertificate;
    }
  });
  applicantDetails?.forEach((applicant) => {
    if (applicant.isSoldier) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `soldireAttachment_applicant_${applicant.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: applicant.nationalId,
            type: "b",
          }),
          file: applicant.soldireAttachment,
          displayName: "soldireAttachment",
        }),
      );

      delete applicant.soldireAttachment;
    }
    if (applicant.adjective === 2) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `attachAgency_applicant_${applicant.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: applicant.nationalId,
            type: "b",
          }),
          file: applicant.attachAgency,
          displayName: "attachAgency",
        }),
      );

      delete applicant.attachAgency;

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `attachAgency2_applicant_${applicant.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: applicant.nationalId,
            type: "b",
          }),
          file: applicant.attachAgency2,
          displayName: "attachAgency2",
        }),
      );

      delete applicant.attachAgency2;
    } else if (applicant.adjective === 4) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `deputyAttach_applicant_${applicant.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: applicant.nationalId,
            type: "b",
          }),
          file: applicant.deputyAttach,
          displayName: "deputyAttach",
        }),
      );

      delete applicant.deputyAttach;
    } else if (applicant.adjective === 3 || applicant.adjective === 5) {
      applicant.selectedArguments?.forEach((item) => {
        if (+item.mainArgumentTypeCode === 4) {
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: newCamunda,
              name: `mortgageAuthorizationAttachment_${item.secondaryArgumentTypeCode}_applicant_${applicant.nationalId}`,
              personalInfoValue: JSON.stringify({
                id: applicant.nationalId,
                type: "b",
              }),
              file: applicant[
                `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
              ],
              displayName: "salesAuthorizationAttachment",
            }),
          );

          delete applicant[
            `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          ];
        }
      });

      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `guardianshipAttachment_applicant_${applicant.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: applicant.nationalId,
            type: "b",
          }),
          file: applicant.guardianshipAttachment,
          displayName: "guardianshipAttachment",
        }),
      );

      delete applicant.guardianshipAttachment;
    }

    if (applicant.passport) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `passport_applicant_${applicant.nationalId}`,
          personalInfoValue: JSON.stringify({ id: applicant.nationalId }),
          file: applicant.passport,
          displayName: "passport",
        }),
      );

      delete applicant.passport;
    }

    if (applicant.commercialRegisterRegistrationCertificate) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `commercialRegisterRegistrationCertificate_applicant_${applicant.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: applicant.nationalId,
            type: "b",
          }),
          file: applicant.commercialRegisterRegistrationCertificate,
          displayName: "commercialRegisterRegistrationCertificate",
        }),
      );

      delete applicant.commercialRegisterRegistrationCertificate;
    }
  });

  if (clearanceAttachment) {
    myAttch.push(
      getAttchmentObject({
        isNewCamunda: newCamunda,
        name: `clearanceAttachment`,
        personalInfoValue: JSON.stringify({ id: "", type: "b" }),
        file: clearanceAttachment,
        displayName: "clearanceAttachment",
      }),
    );

    delete objForAttachment.clearanceAttachment;
  }
  if (rest.acknowledgmentExcuseDoc) {
    myAttch.push(
      getAttchmentObject({
        isNewCamunda: newCamunda,
        name: `acknowledgmentExcuseDoc`,
        personalInfoValue: JSON.stringify({ id: "", type: "b" }),
        file: rest.acknowledgmentExcuseDoc,
        displayName: "acknowledgmentExcuseDoc",
      }),
    );

    delete objForAttachment.acknowledgmentExcuseDoc;
  }
  if (Object.keys(detectionResultAttach || {}).length) {
    for (const key in detectionResultAttach) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `detectionResultAttach_${key}`,
          personalInfoValue: JSON.stringify({ id: "", type: "b" }),
          file: detectionResultAttach[key],
          displayName: "detectionResultAttach",
        }),
      );
    }
    delete objForAttachment.detectionResultAttach;
  }
  if (Object.keys(fieldMonitoringForm || {}).length) {
    for (const key in fieldMonitoringForm) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `fieldMonitoringForm_${key}`,
          personalInfoValue: JSON.stringify({ id: "", type: "b" }),
          file: fieldMonitoringForm[key],
          displayName: "fieldMonitoringForm",
        }),
      );
    }
    delete objForAttachment.fieldMonitoringForm;
  }
  if (Object.keys(fieldMonitoringFormPdf || {}).length) {
    for (const key in fieldMonitoringFormPdf) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `fieldMonitoringFormPdf_${key}`,
          personalInfoValue: JSON.stringify({ id: "", type: "b" }),
          file: fieldMonitoringFormPdf[key],
          displayName: "fieldMonitoringFormPdf",
        }),
      );
    }
    delete objForAttachment.fieldMonitoringFormPdf;
  }
  if (Object.keys(referencePointsAttach || {}).length) {
    for (const key in referencePointsAttach) {
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `referencePointsAttach_${key}`,
          personalInfoValue: JSON.stringify({ id: "", type: "b" }),
          file: referencePointsAttach[key],
          displayName: "referencePointsAttach",
        }),
      );
    }
    delete objForAttachment.referencePointsAttach;
  }

  if (noObjectionDoc) {
    myAttch.push(
      getAttchmentObject({
        isNewCamunda: newCamunda,
        name: `noObjectionDoc`,
        personalInfoValue: JSON.stringify({ id: "", type: "b" }),
        file: noObjectionDoc,
        displayName: "noObjectionDoc",
      }),
    );

    delete objForAttachment.noObjectionDoc;
  }

  if (objForAttachment.inheritanceDoc) {
    myAttch.push(
      getAttchmentObject({
        isNewCamunda: newCamunda,
        name: `deathCert`,
        personalInfoValue: JSON.stringify({ id: "", type: "b" }),
        file: objForAttachment.inheritanceDoc,
        displayName: "inheritanceDoc",
      }),
    );

    delete objForAttachment.inheritanceDoc;
  }

  if (objForAttachment.takharogDoc) {
    myAttch.push(
      getAttchmentObject({
        isNewCamunda: newCamunda,
        name: `deathCert`,
        personalInfoValue: JSON.stringify({ id: "", type: "b" }),
        file: objForAttachment.takharogDoc,
        displayName: "takharogDoc",
      }),
    );
    delete objForAttachment.takharogDoc;
  }

  if (objForAttachment.correctionDoc) {
    myAttch.push(
      getAttchmentObject({
        isNewCamunda: newCamunda,
        name: `deathCert`,
        personalInfoValue: JSON.stringify({ id: "", type: "b" }),
        file: objForAttachment.correctionDoc,
        displayName: "correctionDoc",
      }),
    );

    delete objForAttachment.correctionDoc;
  }

  if (endowmentDoc) {
    myAttch.push(
      getAttchmentObject({
        isNewCamunda: newCamunda,
        name: `endowmentDoc`,
        personalInfoValue: JSON.stringify({ id: "", type: "b" }),
        file: endowmentDoc,
        displayName: "endowmentDoc",
      }),
    );

    delete objForAttachment.endowmentDoc;
  }

  if (objForAttachment.clearanceAttachment) {
    myAttch.push(
      getAttchmentObject({
        isNewCamunda: newCamunda,
        name: `clearanceAttachment`,
        personalInfoValue: JSON.stringify({ id: "", type: "b" }),
        file: objForAttachment.clearanceAttachment,
        displayName: "clearanceAttachment",
      }),
    );

    delete objForAttachment.clearanceAttachment;
  }

  if (objForAttachment.hodClearance) {
    myAttch.push(
      getAttchmentObject({
        isNewCamunda: newCamunda,
        name: `hodClearance`,
        personalInfoValue: JSON.stringify({ id: "", type: "b" }),
        file: objForAttachment.hodClearance,
        displayName: "hodClearance",
      }),
    );

    delete objForAttachment.hodClearance;
  }

  if (["DLS4013", "DLS4012"].includes(serviceCode)) {
    Object.keys(attachments).forEach((key) => {
      attachments[key].forEach((file) => {
        myAttch.push(
          getAttchmentObject({
            isNewCamunda: newCamunda,
            name: `${file.key}_${key}`,
            personalInfoValue: JSON.stringify({ id: "", type: "b" }),
            file: file.file,
            displayName: file.name,
          }),
        );
      });
    });
  } else {
    attachments?.forEach &&
      attachments?.forEach((file) => {
        myAttch.push(
          getAttchmentObject({
            isNewCamunda: newCamunda,
            name: file.key,
            personalInfoValue: JSON.stringify({ id: "", type: "b" }),
            file: file.file,
            displayName: file.name,
          }),
        );
      });
  }

  return myAttch;
};

const MortgageAttachments = ({ objForAttachment }, newCamunda = false) => {
  let { attachments, selectedShares, deptorsDetails, creditorDetails } =
    objForAttachment;

  const myAttch = [];

  selectedShares.map((share) => {
    if (share.adjective === 2) {
      // myAttch.push({
      //   name: `soldireAttachmentAdj_${share.partyId || share.passport_no}`,
      //   file: {
      //     value: share.soldireAttachmentAdj,
      //     personalInfo: {
      //       value: JSON.stringify({
      //         id: share.partyId || share.passport_no,
      //         type: "s",
      //       }),
      //     },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `soldireAttachmentAdj_${share.partyId || share.passport_no}`,
          personalInfoValue: JSON.stringify({
            id: share.partyId || share.passport_no,
            type: "s",
          }),
          file: share.soldireAttachmentAdj,
          displayName: "soldireAttachmentAdj",
        }),
      );
      delete share.soldireAttachmentAdj;

      if (!share.isInternalAgency) {
        // myAttch.push({
        //   name: `attachAgency_${share.partyId || share.passport_no}_seller`,
        //   file: {
        //     value: share.attachAgency,
        //     personalInfo: {
        //       value: JSON.stringify({
        //         id: share.partyId || share.passport_no,
        //         type: "s",
        //       }),
        //     },
        //   },
        // });
        myAttch.push(
          getAttchmentObject({
            isNewCamunda: newCamunda,
            name: `attachAgency_${share.partyId || share.passport_no}_seller`,
            personalInfoValue: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
            file: share.attachAgency,
            displayName: "attachAgency",
          }),
        );
        delete share.attachAgency;
        // myAttch.push({
        //   name: `attachAgency2_${share.partyId || share.passport_no}_seller`,
        //   file: {
        //     value: share.attachAgency2,
        //     personalInfo: {
        //       value: JSON.stringify({
        //         id: share.partyId || share.passport_no,
        //         type: "s",
        //       }),
        //     },
        //   },
        // });
        myAttch.push(
          getAttchmentObject({
            isNewCamunda: newCamunda,
            name: `attachAgency2_${share.partyId || share.passport_no}_seller`,
            personalInfoValue: JSON.stringify({
              id: share.partyId || share.passport_no,
              type: "s",
            }),
            file: share.attachAgency2,
            displayName: "attachAgency2",
          }),
        );
        delete share.attachAgency2;
      }
    } else if (share.adjective === 4) {
      // myAttch.push({
      //   name: `deputyAttach_${share.partyId || share.passport_no}_seller`,
      //   file: {
      //     value: share.deputyAttach,
      //     personalInfo: {
      //       value: JSON.stringify({
      //         id: share.partyId || share.passport_no,
      //         type: "s",
      //       }),
      //     },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `deputyAttach_${share.partyId || share.passport_no}_seller`,
          personalInfoValue: JSON.stringify({
            id: share.partyId || share.passport_no,
            type: "s",
          }),
          file: share.deputyAttach,
          displayName: "deputyAttach",
        }),
      );
      delete share.deputyAttach;
    } else if (share.adjective === 3 || share.adjective === 5) {
      share.selectedArguments?.forEach((item) => {
        if (+item.mainArgumentTypeCode === 4) {
          // myAttch.push({
          //   name: `mortgageAuthorizationAttachment_${
          //     item.secondaryArgumentTypeCode
          //   }_${share.partyId || share.passport_no}_seller`,
          //   file: {
          //     value:
          //       share[
          //         `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          //       ],
          //     personalInfo: {
          //       value: JSON.stringify({
          //         id: share.partyId || share.passport_no,
          //         type: "s",
          //       }),
          //     },
          //   },
          // });
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: newCamunda,
              name: `mortgageAuthorizationAttachment_${item.secondaryArgumentTypeCode}_${share.partyId || share.passport_no}_seller`,
              personalInfoValue: JSON.stringify({
                id: share.partyId || share.passport_no,
                type: "s",
              }),
              file: share[
                `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
              ],
              displayName: "salesAuthorizationAttachment",
            }),
          );
          delete share[
            `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          ];
        }
      });
      // myAttch.push({
      //   name: `guardianshipAttachment_${
      //     share.partyId || share.passport_no
      //   }_seller`,
      //   file: {
      //     value: share.guardianshipAttachment,
      //     personalInfo: {
      //       value: JSON.stringify({
      //         id: share.partyId || share.passport_no,
      //         type: "s",
      //       }),
      //     },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `guardianshipAttachment_${share.partyId || share.passport_no}_seller`,
          personalInfoValue: JSON.stringify({
            id: share.partyId || share.passport_no,
            type: "s",
          }),
          file: share.guardianshipAttachment,
          displayName: "guardianshipAttachment",
        }),
      );
      delete share.guardianshipAttachment;
    }
  });

  deptorsDetails?.forEach((deptor) => {
    if (deptor.isSoldier) {
      // myAttch.push({
      //   name: `soldireAttachment_${deptor.nationalId}`,
      //   file: {
      //     value: deptor.soldireAttachment,
      //     personalInfo: {
      //       value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
      //     },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `soldireAttachment_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.soldireAttachment,
          displayName: "soldireAttachment",
        }),
      );
      delete deptor.soldireAttachment;
    }
    if (deptor.adjective === 2) {
      // myAttch.push({
      //   name: `attachAgency_${deptor.nationalId}_deptor`,
      //   file: {
      //     value: deptor.attachAgency,
      //     personalInfo: {
      //       value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
      //     },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `attachAgency_${deptor.nationalId}_deptor`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.attachAgency,
          displayName: "attachAgency",
        }),
      );
      delete deptor.attachAgency;
      // myAttch.push({
      //   name: `attachAgency2_${deptor.nationalId}_deptor`,
      //   file: {
      //     value: deptor.attachAgency2,
      //     personalInfo: {
      //       value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
      //     },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `attachAgency2_${deptor.nationalId}_deptor`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.attachAgency2,
          displayName: "attachAgency2",
        }),
      );
      delete deptor.attachAgency2;
    } else if (deptor.adjective === 4) {
      // myAttch.push({
      //   name: `deputyAttach_${deptor.nationalId}`,
      //   file: {
      //     value: deptor.deputyAttach,
      //     personalInfo: {
      //       value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
      //     },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `deputyAttach_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.deputyAttach,
          displayName: "deputyAttach",
        }),
      );
      delete deptor.deputyAttach;
    } else if (deptor.adjective === 3 || deptor.adjective === 5) {
      deptor.selectedArguments?.forEach((item) => {
        if (+item.mainArgumentTypeCode === 4) {
          // myAttch.push({
          //   name: `mortgageAuthorizationAttachment_${item.secondaryArgumentTypeCode}_${deptor.nationalId}`,
          //   file: {
          //     value:
          //       deptor[
          //         `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          //       ],
          //     personalInfo: {
          //       value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
          //     },
          //   },
          // });
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: newCamunda,
              name: `mortgageAuthorizationAttachment_${item.secondaryArgumentTypeCode}_${deptor.nationalId}`,
              personalInfoValue: JSON.stringify({
                id: deptor.nationalId,
                type: "b",
              }),
              file: deptor[
                `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
              ],
              displayName: "salesAuthorizationAttachment",
            }),
          );
          delete deptor[
            `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          ];
        }
      });
      // myAttch.push({
      //   name: `mortgageAuthorizationAttachment_${deptor.nationalId}`,
      //   file: {
      //     value: deptor.mortgageAuthorizationAttachment,
      //     personalInfo: {
      //       value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
      //     },
      //   },
      // });
      // myAttch.push({
      //   name: `guardianshipAttachment_${deptor.nationalId}`,
      //   file: {
      //     value: deptor.guardianshipAttachment,
      //     personalInfo: {
      //       value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
      //     },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `guardianshipAttachment_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.guardianshipAttachment,
          displayName: "guardianshipAttachment",
        }),
      );
      // delete deptor.salesAuthorizationAttachment;
      delete deptor.guardianshipAttachment;
    }

    if (deptor.passport) {
      // myAttch.push({
      //   name: `passport_${deptor.nationalId}_deptor`,
      //   file: {
      //     value: deptor.passport,
      //     personalInfo: { value: JSON.stringify({ id: deptor.nationalId }) },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `passport_${deptor.nationalId}_deptor`,
          personalInfoValue: JSON.stringify({ id: deptor.nationalId }),
          file: deptor.passport,
          displayName: "passport",
        }),
      );
      delete deptor.passport;
    }

    if (deptor.commercialRegisterRegistrationCertificate) {
      // myAttch.push({
      //   name: `commercialRegisterRegistrationCertificate_${deptor.nationalId}`,
      //   file: {
      //     value: deptor.commercialRegisterRegistrationCertificate,
      //     personalInfo: {
      //       value: JSON.stringify({ id: deptor.nationalId, type: "b" }),
      //     },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `commercialRegisterRegistrationCertificate_${deptor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: deptor.nationalId,
            type: "b",
          }),
          file: deptor.commercialRegisterRegistrationCertificate,
          displayName: "commercialRegisterRegistrationCertificate",
        }),
      );
      delete deptor.commercialRegisterRegistrationCertificate;
    }
  });
  creditorDetails?.forEach((creditor) => {
    if (creditor.isSoldier) {
      // myAttch.push({
      //   name: `soldireAttachment_${creditor.nationalId}`,
      //   file: {
      //     value: creditor.soldireAttachment,
      //     personalInfo: {
      //       value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
      //     },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `soldireAttachment_${creditor.nationalId}`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.soldireAttachment,
          displayName: "soldireAttachment",
        }),
      );
      delete creditor.soldireAttachment;
    }
    if (creditor.adjective === 2) {
      // myAttch.push({
      //   name: `attachAgency_${creditor.nationalId}_creditor`,
      //   file: {
      //     value: creditor.attachAgency,
      //     personalInfo: {
      //       value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
      //     },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `attachAgency_${creditor.nationalId}_creditor`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.attachAgency,
          displayName: "attachAgency",
        }),
      );
      delete creditor.attachAgency;
      // myAttch.push({
      //   name: `attachAgency2_${creditor.nationalId}_creditor`,
      //   file: {
      //     value: creditor.attachAgency2,
      //     personalInfo: {
      //       value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
      //     },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `attachAgency2_${creditor.nationalId}_creditor`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.attachAgency2,
          displayName: "attachAgency2",
        }),
      );
      delete creditor.attachAgency2;
    } else if (creditor.adjective === 4) {
      // myAttch.push({
      //   name: `deputyAttach_${creditor.nationalId}_creditor`,
      //   file: {
      //     value: creditor.deputyAttach,
      //     personalInfo: {
      //       value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
      //     },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `deputyAttach_${creditor.nationalId}_creditor`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.deputyAttach,
          displayName: "deputyAttach",
        }),
      );
      delete creditor.deputyAttach;
    } else if (creditor.adjective === 3 || creditor.adjective === 5) {
      creditor.selectedArguments?.forEach((item) => {
        if (+item.mainArgumentTypeCode === 4) {
          // myAttch.push({
          //   name: `mortgageAuthorizationAttachment_${item.secondaryArgumentTypeCode}_${creditor.nationalId}_creditor`,
          //   file: {
          //     value:
          //       creditor[
          //         `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          //       ],
          //     personalInfo: {
          //       value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
          //     },
          //   },
          // });
          myAttch.push(
            getAttchmentObject({
              isNewCamunda: newCamunda,
              name: `mortgageAuthorizationAttachment_${item.secondaryArgumentTypeCode}_${creditor.nationalId}_creditor`,
              personalInfoValue: JSON.stringify({
                id: creditor.nationalId,
                type: "b",
              }),
              file: creditor[
                `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
              ],
              displayName: "salesAuthorizationAttachment",
            }),
          );
          delete creditor[
            `salesAuthorizationAttachment_${item.secondaryArgumentTypeCode}`
          ];
        }
      });
      // myAttch.push({
      //   name: `mortgageAuthorizationAttachment_${creditor.nationalId}_creditor`,
      //   file: {
      //     value: creditor.mortgageAuthorizationAttachment,
      //     personalInfo: {
      //       value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
      //     },
      //   },
      // });
      // myAttch.push({
      //   name: `guardianshipAttachment_${creditor.nationalId}_creditor`,
      //   file: {
      //     value: creditor.guardianshipAttachment,
      //     personalInfo: {
      //       value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
      //     },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `guardianshipAttachment_${creditor.nationalId}_creditor`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.guardianshipAttachment,
          displayName: "guardianshipAttachment",
        }),
      );
      // delete creditor.salesAuthorizationAttachment;
      delete creditor.guardianshipAttachment;
    }

    if (creditor.passport) {
      // myAttch.push({
      //   name: `passport_${creditor.nationalId}_creditor`,
      //   file: {
      //     value: creditor.passport,
      //     personalInfo: { value: JSON.stringify({ id: creditor.nationalId }) },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `passport_${creditor.nationalId}_creditor`,
          personalInfoValue: JSON.stringify({ id: creditor.nationalId }),
          file: creditor.passport,
          displayName: "passport",
        }),
      );
      delete creditor.passport;
    }

    if (creditor.commercialRegisterRegistrationCertificate) {
      // myAttch.push({
      //   name: `commercialRegisterRegistrationCertificate_${creditor.nationalId}_creditor`,
      //   file: {
      //     value: creditor.commercialRegisterRegistrationCertificate,
      //     personalInfo: {
      //       value: JSON.stringify({ id: creditor.nationalId, type: "b" }),
      //     },
      //   },
      // });
      myAttch.push(
        getAttchmentObject({
          isNewCamunda: newCamunda,
          name: `commercialRegisterRegistrationCertificate_${creditor.nationalId}_creditor`,
          personalInfoValue: JSON.stringify({
            id: creditor.nationalId,
            type: "b",
          }),
          file: creditor.commercialRegisterRegistrationCertificate,
          displayName: "commercialRegisterRegistrationCertificate",
        }),
      );
      delete creditor.commercialRegisterRegistrationCertificate;
    }
  });

  if (objForAttachment.clearanceAttachment) {
    // myAttch.push({
    //   name: "clearanceAttachment",
    //   file: { value: objForAttachment.clearanceAttachment },
    // });
    myAttch.push(
      getAttchmentObject({
        isNewCamunda: newCamunda,
        name: "clearanceAttachment",
        personalInfoValue: JSON.stringify({ id: "", type: "b" }),
        file: objForAttachment.clearanceAttachment,
        displayName: "clearanceAttachment",
      }),
    );
    delete objForAttachment.clearanceAttachment;
  }
  attachments?.forEach((file) => {
    // myAttch.push({
    //   name: file.key,
    //   file: { value: file.file },
    // });
    myAttch.push(
      getAttchmentObject({
        isNewCamunda: newCamunda,
        name: file.key,
        file: file.file,
        displayName: file.name,
      }),
    );
  });

  return myAttch;
};

const attachmentsFunctionDecider = ({ serviceCode, objForAttachment }) => {
  switch (serviceCode) {
    case "DLS1029":
      return MortgageAttachments({ objForAttachment });
    default:
      return OwnershipTransferAttachments({ objForAttachment }, serviceCode);
  }
};
const attachmentsFunctionDeciderNew = (
  { serviceCode, objForAttachment },
  newCamunda = false,
) => {
  switch (serviceCode) {
    case "DLS1029":
      return MortgageAttachments({ objForAttachment }, newCamunda);
    default:
      return OwnershipTransferAttachmentsNew(
        { objForAttachment },
        serviceCode,
        newCamunda,
      );
  }
};

export const langLettersOnly =
  i18n.language === "ar" ? /^[\u0621-\u064A\u0660-\u0669 ]+$/ : /^[a-zA-Z]+$/;

const checkMuslimsLoop = (array) => {
  for (let index = 0; index < array?.length; index++) {
    const element = array[index];
    if (
      (element.adjective === 3 || element.adjective === 5) &&
      element.religionCode === "01"
    ) {
      return true;
    }
  }
  return false;
};

const checkIfThereAreMuslims = (objForAttachment) => {
  const {
    selectedShares,
    buyersDetails,
    deptorsDetails,
    creditorDetails,
    rentalsDetails,
    exchangedProperty,
    applicantInfo,
    applicantDetails,
  } = objForAttachment;

  if (selectedShares && checkMuslimsLoop(selectedShares)) {
    return true;
  }
  if (buyersDetails && checkMuslimsLoop(buyersDetails)) {
    return true;
  }
  if (deptorsDetails && checkMuslimsLoop(deptorsDetails)) {
    return true;
  }
  if (creditorDetails && checkMuslimsLoop(creditorDetails)) {
    return true;
  }
  if (rentalsDetails && checkMuslimsLoop(rentalsDetails)) {
    return true;
  }
  if (applicantDetails && checkMuslimsLoop(applicantDetails)) {
    return true;
  }
  if (
    (applicantInfo?.adjective === 3 || applicantInfo?.adjective === 5) &&
    applicantInfo?.religionCode === "01"
  ) {
    return true;
  }
  if (
    exchangedProperty &&
    exchangedProperty[0] &&
    checkMuslimsLoop(exchangedProperty[0].selectedShares)
  ) {
    return true;
  }

  return false;
};
export const prepareObjForCamunda = (
  obj,
  refrenceNumber,
  serviceCode,
  serviceETitle,
  serviceTitle,
  options = {},
) => {
  let {
    taskId,
    processInstanceId,
    contractNo,
    attachments,
    selectedShares,
    buyersDetails,
    clearanceAttachment,
    noObjectionDoc,
    deptorsDetails,
    creditorDetails,
    ...rest
  } = obj;
  const { propertyData } = rest;

  rest = {
    ...rest,
    status: "قيد الدراسة",
    refrenceNumber: refrenceNumber,
    serviceCode: serviceCode,
    serviceTitle: serviceTitle,
    // "nationalId": userInfo.nationalId,
    taskType: { en: serviceETitle, ar: serviceTitle },
    Number: +propertyData.depT_CODE,
    created: moment().format(),
  };

  const objForAttachment = JSON.parse(JSON.stringify(obj, replacer));

  return {
    id: taskId,
    processInstanceId: processInstanceId,
    regNumber: propertyData.reG_NO,
    status: "قيد الدراسة",
    refrenceNumber: refrenceNumber,
    serviceCode: serviceCode,
    serviceTitle: serviceTitle,
    attachments: attachmentsFunctionDecider({ serviceCode, objForAttachment }),
    // "nationalId": userInfo.nationalId,
    Number: +propertyData.depT_CODE,
    SendtoDCJ: options.endowment ? true : false,
    message: `عزيزي المواطن\nتم إرسال الطلب رقم ${refrenceNumber} لمعاملة ${serviceTitle}\nالحكومة الإلكترونية لخدمة الأردن`,
    notificationEmail: getSubmittedEmail({ serviceTitle, refrenceNumber }),
    // attachments,
    variables: {
      object: {
        value: JSON.stringify(
          {
            ...rest,
            contractNo,
            selectedShares: objForAttachment.selectedShares,
            buyersDetails: objForAttachment.buyersDetails,
            deptorsDetails: objForAttachment.deptorsDetails,
            creditorDetails: objForAttachment.creditorDetails,
            rentalsDetails: objForAttachment.rentalsDetails,
            applicantDetails: objForAttachment.applicantDetails,
            buyerSellersMapper: objForAttachment.buyerSellersMapper,
            exchangedProperty: objForAttachment.exchangedProperty || "",
            applicantInfo: objForAttachment.applicantInfo || "",
            detectionResultAttach:
              objForAttachment?.detectionResultAttach || "",
            fieldMonitoringForm: objForAttachment?.fieldMonitoringForm || "",
            referencePointsAttach:
              objForAttachment?.referencePointsAttach || "",
          },
          replacerObject,
        ),
        type: "Json",
      },
      Number: { value: propertyData.depT_CODE },
      SendtoDCJ: { value: `${options.endowment ? true : false}` },
      regNO: { value: propertyData.reG_NO },
      contractNo,
    },
    withVariablesInReturn: true,
    created: moment().format(),
  };
};

export const prepareObjForCamundaNew = (
  obj,
  refrenceNumber,
  serviceCode,
  serviceETitle,
  serviceTitle,
  checkReligion = false,
  options = {
    newCamunda: false,
    extraVariables: {},
    otpValue: "",
  },
) => {
  let {
    taskId,
    processInstanceId,
    contractNo,
    attachments,
    selectedShares,
    buyersDetails,
    clearanceAttachment,
    noObjectionDoc,
    deptorsDetails,
    creditorDetails,
    ...rest
  } = obj;
  const { propertyData } = rest;

  rest = {
    ...rest,
    status: options.status ? options.status : "قيد الدراسة",
    refrenceNumber: refrenceNumber,
    serviceCode: serviceCode,
    serviceTitle: serviceTitle,
    // "nationalId": userInfo.nationalId,
    taskType: { en: serviceETitle, ar: serviceTitle },
    Number: +propertyData.depT_CODE,
    created: moment().format(),
    ...options.extraVariables,
  };

  const objForAttachment = JSON.parse(JSON.stringify(obj, replacer));

  let isThereMuslim = false;

  if (checkReligion) {
    isThereMuslim = checkIfThereAreMuslims(objForAttachment);
  }
  const convertedExtraVariables = {};

  if (options.extraVariables) {
    Object.keys(options.extraVariables).forEach((key) => {
      if (
        key !== "status" &&
        typeof options.extraVariables[key] !== "undefined"
      ) {
        convertedExtraVariables[key] = {
          value: `${options.extraVariables[key]}`,
        };
      }
    });
  }

  const myAttch = options.newCamunda
    ? attachmentsFunctionDeciderNew(
      {
        serviceCode,
        objForAttachment,
      },
      options.newCamunda,
    ).filter((item) => item.arrachmentStr)
    : attachmentsFunctionDeciderNew(
      {
        serviceCode,
        objForAttachment,
      },
      options.newCamunda,
    );

  const maplstAttachmentsToVariables = {};
  if (options.newCamunda) {
    if (myAttch && myAttch.length) {
      myAttch.forEach((item) => {
        let base64 = (item.arrachmentStr || item.attachmentStr)
          ?.replace(/"/g, "")
          .trim();

        if (base64) {
          maplstAttachmentsToVariables[item.key] = {
            type: "Json",
            value: JSON.stringify({
              value: base64,
            }),
          };
        }
      });
    }
  }
  const otpVariable = options.otpValue ? { OTP: options.otpValue } : {};
  return {
    id: taskId,
    processInstanceId: processInstanceId,
    regNumber: propertyData.reG_NO,
    status: options.status ? options.status : "قيد الدراسة",
    refrenceNumber: refrenceNumber,
    serviceCode: serviceCode,
    serviceTitle: serviceTitle,
    attachments: myAttch,
    // "nationalId": userInfo.nationalId,
    Number: +propertyData.depT_CODE,
    SendtoDCJ: isThereMuslim,
    message: `عزيزي المواطن\nتم إرسال الطلب رقم ${refrenceNumber} لمعاملة ${serviceTitle}\nالحكومة الإلكترونية لخدمة الأردن`,
    notificationEmail: getSubmittedEmail({ serviceTitle, refrenceNumber }),
    // attachments,
    ...options.extraVariables,
    variables: {
      object: {
        value: JSON.stringify(
          {
            ...rest,
            contractNo,
            selectedShares: objForAttachment.selectedShares,
            buyersDetails: objForAttachment.buyersDetails,
            deptorsDetails: objForAttachment.deptorsDetails,
            creditorDetails: objForAttachment.creditorDetails,
            rentalsDetails: objForAttachment.rentalsDetails,
            applicantDetails: objForAttachment.applicantDetails,
            buyerSellersMapper: objForAttachment.buyerSellersMapper,
            exchangedProperty: objForAttachment.exchangedProperty || "",
            applicantInfo: objForAttachment.applicantInfo || "",
            detectionResultAttach:
              objForAttachment?.detectionResultAttach || "",
            fieldMonitoringForm: objForAttachment?.fieldMonitoringForm || "",
            referencePointsAttach:
              objForAttachment?.referencePointsAttach || "",
            deceasedAgent: objForAttachment?.deceasedAgent,
            fieldMonitoringFormPdf: {},
          },
          replacerObject,
        ),
        type: "Json",
      },
      Number: { value: propertyData.depT_CODE },
      SendtoDCJ: { value: `${isThereMuslim}` },
      regNO: { value: propertyData.reG_NO || "" },
      contractNo,
      ...convertedExtraVariables,
      // ...maplstAttachmentsToVariables,
    },
    ...otpVariable,
    withVariablesInReturn: true,
    created: moment().format(),
  };
};

export const prepareAuthObjForCamunda = (
  obj,
  refrenceNumber,
  serviceCode,
  serviceETitle,
  serviceTitle,
  options = {
    newCamunda: false,
  },
) => {
  let {
    taskId,
    processInstanceId,
    contractNo,
    attachments,
    selectedShares,
    buyersDetails,
    clearanceAttachment,
    noObjectionDoc,
    deptorsDetails,
    creditorDetails,
    ...rest
  } = obj;
  const { propertyData } = rest;

  let authNum = null;

  if (serviceCode === "DLS1011") {
    authNum = 201;
  } else if (serviceCode === "DLS1022") {
    authNum = 203;
  } else if (serviceCode === "DLS1019") {
    authNum = 204;
  } else if (serviceCode === "DLS1020") {
    authNum = 202;
  }

  rest = {
    ...rest,
    status: "قيد الدراسة",
    refrenceNumber: refrenceNumber,
    serviceCode: serviceCode,
    serviceTitle: serviceTitle,
    // "nationalId": userInfo.nationalId,
    taskType: { en: serviceETitle, ar: serviceTitle },
    // Number: +propertyData.depT_CODE,
    created: moment().format(),
  };

  const objForAttachment = JSON.parse(JSON.stringify(obj, replacer));

  const isThereMuslim = checkIfThereAreMuslims(objForAttachment);

  return {
    id: taskId,
    processInstanceId: processInstanceId,
    regNumber: propertyData.reG_NO,
    status: "قيد الدراسة",
    refrenceNumber: refrenceNumber,
    serviceCode: serviceCode,
    serviceTitle: serviceTitle,
    attachments: attachmentsFunctionDeciderNew(
      {
        serviceCode,
        objForAttachment,
      },
      options.newCamunda,
    ),
    // "nationalId": userInfo.nationalId,
    // Number: +propertyData.depT_CODE,
    SendtoDCJ: isThereMuslim,
    message: `عزيزي المواطن\nتم إرسال الطلب رقم ${refrenceNumber} لمعاملة ${serviceTitle}\nالحكومة الإلكترونية لخدمة الأردن`,
    notificationEmail: getSubmittedEmail({ serviceTitle, refrenceNumber }),
    // attachments,
    variables: {
      object: {
        value: JSON.stringify(
          {
            ...rest,
            selectedShares: objForAttachment.selectedShares,
            buyersDetails: objForAttachment.buyersDetails,
            deptorsDetails,
            creditorDetails,
            buyerSellersMapper: objForAttachment.buyerSellersMapper,
          },
          replacerObject,
        ),
        type: "Json",
      },
      Number: { value: propertyData.depT_CODE },
      SendtoDCJ: { value: `${isThereMuslim}` },
      Authority_Num: { value: `${authNum}` },
      regNO: { value: propertyData.reG_NO },
      contractNo,
    },
    withVariablesInReturn: true,
    created: moment().format(),
  };
};

export const prepareObjForCamundaRefund = (
  obj,
  refrenceNumber,
  serviceCode,
  serviceETitle,
  serviceTitle,
) => {
  let {
    taskId,
    processInstanceId,
    contractNo,
    attachments,
    selectedShares,
    buyersDetails,
    clearanceAttachment,
    noObjectionDoc,
    deptorsDetails,
    creditorDetails,
    ...rest
  } = obj;
  const { propertyData } = rest;
  const parentRefrenceNumber = rest.refrenceNumber;

  let Number = +propertyData.depT_CODE;
  let regNO = propertyData.reG_NO;

  if (rest.serviceCode === "DLS4012" || rest.serviceCode === "DLS4013") {
    Number = rest.propertiesDetails[0].depT_CODE;
    regNO = rest.propertiesDetails.map((prop) => prop.reG_NO).join(".");
  }

  rest = {
    ...rest,
    status: "قيد الدراسة",
    refrenceNumber: refrenceNumber,
    parentRefrenceNumber: parentRefrenceNumber,
    serviceCode: serviceCode,
    serviceTitle: serviceTitle,
    // "nationalId": userInfo.nationalId,
    taskType: { en: serviceETitle, ar: serviceTitle },
    Number: +Number,
    orderNO: parentRefrenceNumber,
    created: moment().format(),
  };

  const objForAttachment = JSON.parse(JSON.stringify(obj, replacer));

  const myAttch = attachmentsFunctionDeciderNew(
    { serviceCode, objForAttachment },
    true,
  ).filter((item) => item.arrachmentStr);

  const maplstAttachmentsToVariables = {};

  if (myAttch && myAttch.length) {
    myAttch.forEach((item) => {
      let base64 = (item.arrachmentStr || item.attachmentStr)
        ?.replace(/"/g, "")
        .trim();

      if (base64) {
        maplstAttachmentsToVariables[item.key] = {
          type: "Json",
          value: JSON.stringify({
            value: base64,
          }),
        };
      }
    });
  }

  return {
    id: taskId,
    processInstanceId: processInstanceId,
    regNumber: regNO,
    status: "قيد الدراسة",
    refrenceNumber: refrenceNumber,
    serviceCode: serviceCode,
    serviceTitle: serviceTitle,
    attachments: attachmentsFunctionDeciderNew(
      { serviceCode, objForAttachment },
      true,
    ).filter((item) => item.arrachmentStr),
    // "nationalId": userInfo.nationalId,
    Number: +Number,
    message: `عزيزي المواطن\nتم إرسال الطلب رقم ${refrenceNumber} لمعاملة ${serviceTitle}\nالحكومة الإلكترونية لخدمة الأردن`,
    notificationEmail: getSubmittedEmail({ serviceTitle, refrenceNumber }),
    // attachments,
    variables: {
      object: {
        value: JSON.stringify(
          {
            ...rest,
            selectedShares: objForAttachment.selectedShares,
            buyersDetails: objForAttachment.buyersDetails,
            deptorsDetails,
            creditorDetails,
            buyerSellersMapper: objForAttachment.buyerSellersMapper,
          },
          replacerObject,
        ),
        type: "Json",
      },
      Number: { value: `${Number}` },
      regNO: { value: regNO },
      orderNO: { value: parentRefrenceNumber },
      parentRefrenceNumber: { value: parentRefrenceNumber },
      contractNo,
      // ...maplstAttachmentsToVariables,
    },
    withVariablesInReturn: true,
    created: moment().format(),
  };
};

export const prepareObjForCamundaEfrazMerge = (
  obj,
  refrenceNumber,
  serviceCode,
  serviceETitle,
  serviceTitle,
  options = {
    extraVariables: {},
  },
) => {
  let {
    taskId,
    processInstanceId,
    contractNo,
    attachments,
    selectedShares,
    buyersDetails,
    clearanceAttachment,
    noObjectionDoc,
    deptorsDetails,
    creditorDetails,
    ...rest
  } = obj;
  const { propertiesDetails } = rest;
  rest = {
    ...rest,
    status: options.status ? options.status : "قيد الدراسة",
    refrenceNumber: refrenceNumber,
    serviceCode: serviceCode,
    serviceTitle: serviceTitle,
    // "nationalId": userInfo.nationalId,
    taskType: { en: serviceETitle, ar: serviceTitle },
    Number: +propertiesDetails[0].depT_CODE,
    created: moment().format(),
    ...options.extraVariables,
  };

  const objForAttachmentTemp = JSON.parse(JSON.stringify(obj, replacer));
  const { selectedShares: tempSelectedShares, ...objForAttachment } =
    objForAttachmentTemp;

  let isThereMuslim = false;

  isThereMuslim = checkIfThereAreMuslims(objForAttachment);

  const convertedExtraVariables = {};

  if (options.extraVariables) {
    Object.keys(options.extraVariables).forEach((key) => {
      if (
        key !== "status" &&
        typeof options.extraVariables[key] !== "undefined"
      ) {
        convertedExtraVariables[key] = {
          value: `${options.extraVariables[key]}`,
        };
      }
    });
  }

  return {
    id: taskId,
    processInstanceId: processInstanceId,
    regNumber: propertiesDetails.map((prop) => prop.reG_NO).join("."),
    status: options.status ? options.status : "قيد الدراسة",
    refrenceNumber: refrenceNumber,
    serviceCode: serviceCode,
    serviceTitle: serviceTitle,
    attachments: attachmentsFunctionDecider({ serviceCode, objForAttachment }),
    // "nationalId": userInfo.nationalId,
    Number: +propertiesDetails[0].depT_CODE,
    SendtoDCJ: isThereMuslim,
    message: `عزيزي المواطن\nتم إرسال الطلب رقم ${refrenceNumber} لمعاملة ${serviceTitle}\nالحكومة الإلكترونية لخدمة الأردن`,
    notificationEmail: getSubmittedEmail({ serviceTitle, refrenceNumber }),
    // attachments,
    ...options.extraVariables,
    variables: {
      object: {
        value: JSON.stringify(
          {
            ...rest,
            selectedShares: tempSelectedShares,
            buyersDetails: objForAttachment.buyersDetails,
            propertiesDetails: objForAttachment.propertiesDetails,
            deptorsDetails,
            creditorDetails,
            buyerSellersMapper: objForAttachment.buyerSellersMapper,
            detectionResultAttach: {},
            fieldMonitoringForm: {},
            fieldMonitoringFormPdf: {},
            referencePointsAttach: {},
          },
          replacerObject,
        ),
        type: "Json",
      },
      Number: { value: propertiesDetails[0].depT_CODE },
      SendtoDCJ: { value: `${isThereMuslim}` },
      regNO: { value: propertiesDetails.map((prop) => prop.reG_NO).join(".") },
      contractNo,
      ...convertedExtraVariables,
    },
    withVariablesInReturn: true,
    created: moment().format(),
  };
};

export const prepareAgencyObjForCamunda = (
  obj,
  refrenceNumber,
  serviceCode,
  serviceETitle,
  serviceTitle,
  options = {},
) => {
  let {
    taskId,
    processInstanceId,
    contractNo,
    attachments,
    selectedShares,
    buyersDetails,
    clearanceAttachment,
    noObjectionDoc,
    deptorsDetails,
    creditorDetails,
    ...rest
  } = obj;
  const { propertyData } = rest;
  rest = {
    ...rest,
    status: options.status ? options.status : "قيد الدراسة",
    refrenceNumber: refrenceNumber,
    agencyNo: obj.agencyDetails.agencyNumber,
    serviceCode: serviceCode,
    serviceTitle: serviceTitle,
    // "nationalId": userInfo.nationalId,
    taskType: { en: serviceETitle, ar: serviceTitle },
    Number: +propertyData.depT_CODE,
    created: moment().format(),
  };

  const objForAttachment = JSON.parse(JSON.stringify(obj, replacer));

  return {
    id: taskId,
    processInstanceId: processInstanceId,
    regNumber: propertyData.reG_NO,
    status: options.status ? options.status : "قيد الدراسة",
    refrenceNumber: refrenceNumber,
    serviceCode: serviceCode,
    serviceTitle: serviceTitle,
    attachments: attachmentsFunctionDecider({ serviceCode, objForAttachment }),
    // "nationalId": userInfo.nationalId,
    Number: +propertyData.depT_CODE,
    message: `عزيزي المواطن\nتم إرسال الطلب رقم ${refrenceNumber} لمعاملة ${serviceTitle}\nالحكومة الإلكترونية لخدمة الأردن`,
    notificationEmail: getSubmittedEmail({ serviceTitle, refrenceNumber }),
    // attachments,
    variables: {
      object: {
        value: JSON.stringify(
          {
            ...rest,
            selectedShares: objForAttachment.selectedShares,
            buyersDetails: objForAttachment.buyersDetails,
            deptorsDetails,
            creditorDetails,
            buyerSellersMapper: objForAttachment.buyerSellersMapper,
          },
          replacerObject,
        ),
        type: "Json",
      },
      Number: { value: propertyData.depT_CODE || "7" },
      regNO: { value: propertyData.reG_NO || "" },
      agencyNo: { value: obj.agencyDetails.agencyNumber },
      contractNo,
    },
    withVariablesInReturn: true,
    created: moment().format(),
  };
};

export const getAttchmentObj = (base64Obj) => {
  return base64ToArrayBuffer(base64Obj);
};

export const base64ToArrayBuffer = (base64) => {
  let binary_string = window.atob(base64);
  let len = binary_string.length;
  let bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
};

export const dataURLtoFile = (dataurl, filename) => {
  let arr = dataurl?.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

export const allowedRenewDelete = (obj) => {
  if (obj["demandType"] === "4") {
    if (
      obj["partyCode"] === "4" ||
      obj["partyCode"] === "1" ||
      obj["partyCode"] === "6" ||
      obj["partyCode"] === "7"
    ) {
      return "office";
    }
  } else if (obj["partyCode"] === "3" && obj["demandType"] === "3") {
    return "servoyer";
  } else if (obj["partyCode"] === "2" && obj["demandType"] === "2") {
    return "estimator";
  }
};

export const hasAccessToken = () => {
  return localStorage.getItem("accessToken");
};

export const getSubmittedMessage = ({ refrenceNumber, serviceTitle }) => {
  return `عزيزي المواطن\nتم إرسال الطلب رقم ${refrenceNumber} لمعاملة ${serviceTitle}\nالحكومة الإلكترونية لخدمة الأردن`;
};

export const getSubmittedEmail = ({ refrenceNumber, serviceTitle }) => {
  return `<h4 style="direction: rtl">عزيزي المواطن<br/><br/>تم إرسال الطلب رقم <span style="direction: ltr">${refrenceNumber}</span> لمعاملة  ${serviceTitle}<br/><br/>الحكومة الإلكترونية لخدمة الأردن</h4>`;
};

// export const prepareParam = (param) => param.replaceAll("#", "%23");
export const prepareParam = (param) => encodeURIComponent(param);

export const getPersonStatus = (deatH_C) => {
  if (deatH_C === 0) {
    return "على قيد الحياة";
  } else if (deatH_C === 1) {
    return "متوفي";
  }
};

export const isValidSellingProcess = (
  buyerSellersMapper,
  totalSellers,
  totalBuyers,
  allShares,
  isTotalShares,
  { transmission, withoutAllSellerShares } = {
    transmission: false,
    withoutAllSellerShares: false,
  },
) => {
  let type = "";
  if (allShares) {
    type = "allShares";
  } else if (isTotalShares) {
    type = "totalShares";
  } else {
    type = "partOfShares";
  }

  const selectedBuyers = [];
  const selectedSellers = [];

  let totalBuyingShares = 0;
  let shareDivisor = 0;

  let totalhierShares = 0;
  let inheritedShares = 0;

  if (transmission) {
    buyerSellersMapper.forEach((ele) => {
      selectedBuyers.push(ele.buyer.nationalId || ele.buyer?.uuid);
      selectedSellers.push(ele.seller.partyId);
      totalBuyingShares += +ele.hierShares / +ele.inheritedShares;

      inheritedShares = +ele.inheritedShares;
      totalhierShares += +ele.hierShares;
    });
  } else {
    buyerSellersMapper.forEach((ele) => {
      selectedBuyers.push(ele.buyer.nationalId);
      selectedSellers.push(ele.seller.partyId);
      shareDivisor = +ele.shareDivisor;
      // totalBuyingShares += +ele.shareDividend / +ele.shareDivisor;
      totalBuyingShares += +ele.shareDividend;
    });
  }

  const isValid =
    totalSellers.length == new Set(selectedSellers).size &&
    totalBuyers.length == new Set(selectedBuyers).size;

  if (!isValid) {
    return [false, "allSellersMustSellAndAllBuyersMustBuy"];
  }

  if (type === "partOfShares") {
    return [true];
  }

  if (transmission) {
    if (type === "totalShares") {
      // all party // كامل العقار
      if (totalhierShares === inheritedShares) {
        // if (totalBuyingShares === 1) {
        return [true];
      } else {
        return [false, "mustDistributeAllProperty"];
      }
    }
  } else {
    if (type === "totalShares") {
      // all party // كامل العقار
      if (totalBuyingShares === shareDivisor) {
        return [true];
      } else {
        return [false, "mustDistributeAllProperty"];
      }
    }
  }

  for (let i = 0; i < totalSellers.length; i++) {
    let tempShareDividend = 0;
    let tempShareDivisor = 0;
    buyerSellersMapper.forEach((buyerSeller) => {
      if (buyerSeller.seller.partyId === totalSellers[i].partyId) {
        tempShareDividend += +buyerSeller.shareDividend;
        tempShareDivisor = +buyerSeller.shareDivisor;
      }
    });

    if (
      +totalSellers[i].shareNo * tempShareDividend ===
      +totalSellers[i].ownShares * tempShareDivisor
    ) {
      // return [true];
    } else {
      return [false, "mustDistributeAllSellersShares"];
    }
  }

  // for (let i = 0; i < buyerSellersMapper.length; i++) {
  //   const s1 = buyerSellersMapper[i].seller;
  //   const s2 = totalSellers.find((ele) => (ele.partyId = s1.partyId));

  //   if (
  //     !s2 ||
  //     +s2.ownShares / +s2.shareNo !=
  //       +buyerSellersMapper[i].shareDividend /
  //         +buyerSellersMapper[i].shareDivisor
  //   ) {
  //     return [false, "mustDistributeAllSellersShares"];
  //   }
  // }
  return [true];
};

export const resetFetchedAgencyInfo = (formik) => {
  // formik.setFieldValue("agentName", "");
  formik.setFieldValue("agencyPlace", "");
  formik.setFieldValue("agencyType", "");
  formik.setFieldValue("agencyStatus", "");
  formik.setFieldValue("agencyClientName", "");
};

export const isSameRequesterOwner = (nationalId) => {
  const userInfo = store.getState().userInfo;
  return userInfo.nationalId === nationalId;
};

export const getUserTypesByPartyCode = (
  partyCode,
  userTypes,
  sellerAge = null,
  typeOfSeller = "",
  partyId = "",
  options = {
    checkWithApplicant: false,
  },
) => {
  let tempArr = [];
  if (options.checkWithApplicant) {
    if (isSameRequesterOwner(partyId)) {
      // if (partyId === "9931011342") {
      tempArr = userTypes;
    } else {
      tempArr = userTypes.filter((user) => user.value !== 1);
    }
  } else {
    tempArr = userTypes;
  }
  if (partyCode === "5") {
    return tempArr.filter((user) => user.value !== 3 && user.value !== 5);
  }
  if (sellerAge && sellerAge < 18 && typeOfSeller !== "auth") {
    return tempArr.filter((user) => user.value === 3 || user.value === 5);
  }
  if (partyCode === "1" || partyCode === "3") {
    return tempArr.filter((user) => user.value !== 4);
  }
  return tempArr.filter((user) => user.value !== 4);
};

export const getUserTypesByBuyerType = (
  userTypes,
  isCompany,
  isSoldier,
  buyerAge = null,
) => {
  if (isCompany) {
    return userTypes.filter((user) => user.value !== 3 && user.value !== 5);
  }
  if (isSoldier) {
    return userTypes.filter(
      (user) => user.value !== 4 && user.value !== 3 && user.value !== 5,
    );
  }
  if (buyerAge && buyerAge < 18) {
    return userTypes.filter((user) => user.value === 3 || user.value === 5);
  }
  return userTypes.filter((user) => user.value !== 4);
};
export const isBuyerInDeputy = (id, sellingFormDetails) => {
  for (
    let index = 0;
    index < sellingFormDetails.selectedShares.length;
    index++
  ) {
    if (
      +sellingFormDetails.selectedShares[index].adjective === 4 &&
      (sellingFormDetails.selectedShares[index].deputyNationalId === id ||
        sellingFormDetails.selectedShares[index].deputyPersonalNumber === id)
    ) {
      return true;
    }
  }
};

export const isDeputyInBuyers = (id, sellingFormDetails) => {
  const temp = sellingFormDetails.buyersDetails || [];
  for (let index = 0; index < temp.length; index++) {
    if (temp[index].nationalId === id && +temp[index].adjective === 1) {
      return true;
    }
  }
};

export const resetClearance = (formik) => {
  formik.setFieldValue("clearanceAttachment", "");
  formik.setFieldValue("isValidClearance", false);
  formik.setFieldValue("isClearanceSearched", false);
};

export const resetRepresentative = (formik) => {
  formik.setFieldValue("agencyNumber", "");
  formik.setFieldValue("attachAgency", "");
  formik.setFieldValue("attachAgency2", "");
  formik.setFieldValue("agencyDate", "");
  formik.setFieldValue("agencyPlace", "");
  formik.setFieldValue("agentName", "");
  formik.setFieldValue("agencyClientName", "");
  formik.setFieldValue("agencyType", "");
  formik.setFieldValue("agencyStatus", "");
  formik.setFieldValue("agentNationalId", "");
  formik.setFieldValue("agentPersonalNumber", "");
  formik.setFieldValue("agentCardNo", "");
  formik.setFieldValue("clientNationalId", "");
  formik.setFieldValue("clientPersonalNumber", "");
  formik.setFieldValue("clientCardNo", "");
  formik.setFieldValue("guardianNationalId", "");
  formik.setFieldValue("guardianPersonalNumber", "");
  formik.setFieldValue("guardianCardNo", "");
  formik.setFieldValue("guardianName", "");
  formik.setFieldValue("guardianshipNumber", "");
  formik.setFieldValue("guardianshipDate", "");
  formik.setFieldValue("guardianshipPlace", "");
  formik.setFieldValue("guardianshipAttachment", "");
  formik.setFieldValue("salesAuthorizationNumber", "");
  formik.setFieldValue("salesAuthorizationDate", "");
  formik.setFieldValue("salesAuthorizationPlace", "");
  formik.setFieldValue("salesAuthorizationAttachment", "");
  formik.setFieldValue("entityNum", "");
  formik.setFieldValue("entityName", "");
  formik.setFieldValue("deputyNum", "");
  formik.setFieldValue("deputyDate", "");
  formik.setFieldValue("phoneNum", "");
  formik.setFieldValue("deputyAttach", "");
  formik.setFieldValue("deputyNationalId", "");
  formik.setFieldValue("deputyPersonalNumber", "");
  formik.setFieldValue("deputyCardNo", "");
  formik.setFieldValue("agentInfo", {});
  formik.setFieldValue("clientInfo", {});
  formik.setFieldValue("guardianInfo", {});
  formik.setFieldValue("minorInfo", {});
  formik.setFieldValue("deputyInfo", {});

  resetAdjective(formik);
};
export const resetAdjectiveData = (formik, options = {}) => {
  if (!options.applicantAsOwner) {
    formik.setFieldValue("agentName", "");
    formik.setFieldValue("agentNationalId", "");
    formik.setFieldValue("agentPersonalNumber", "");
    formik.setFieldValue("agentInfo", {});

    formik.setFieldValue("guardianNationalId", "");
    formik.setFieldValue("guardianPersonalNumber", "");
    formik.setFieldValue("guardianCardNo", "");
    formik.setFieldValue("guardianName", "");
    formik.setFieldValue("guardianInfo", {});
  }
  formik.setFieldValue("agencyNumber", "");
  formik.setFieldValue("attachAgency", "");
  formik.setFieldValue("attachAgency2", "");
  formik.setFieldValue("agencyDate", "");
  formik.setFieldValue("agencyPlace", "");
  formik.setFieldValue("agencyClientName", "");
  formik.setFieldValue("agencyType", "");
  formik.setFieldValue("agencyStatus", "");
  formik.setFieldValue("agentCardNo", "");
  formik.setFieldValue("clientNationalId", "");
  formik.setFieldValue("clientPersonalNumber", "");
  formik.setFieldValue("clientCardNo", "");

  formik.setFieldValue("guardianshipNumber", "");
  formik.setFieldValue("guardianshipDate", "");
  formik.setFieldValue("guardianshipPlace", "");
  formik.setFieldValue("guardianshipAttachment", "");
  formik.setFieldValue("salesAuthorizationNumber", "");
  formik.setFieldValue("salesAuthorizationDate", "");
  formik.setFieldValue("salesAuthorizationPlace", "");
  formik.setFieldValue("salesAuthorizationAttachment", "");
  formik.setFieldValue("entityNum", "");
  formik.setFieldValue("entityName", "");
  formik.setFieldValue("deputyNum", "");
  formik.setFieldValue("deputyDate", "");
  formik.setFieldValue("phoneNum", "");
  formik.setFieldValue("deputyAttach", "");
  formik.setFieldValue("deputyNationalId", "");
  formik.setFieldValue("deputyPersonalNumber", "");
  formik.setFieldValue("deputyCardNo", "");
  formik.setFieldValue("clientInfo", {});

  formik.setFieldValue("minorInfo", {});
  formik.setFieldValue("deputyInfo", {});
};

export const getSellerAdjective = (rowData, options = {}) => {
  const userInfo = store.getState().userInfo;
  const sellingFormDetails = options.refund
    ? store.getState().sellingFormDetails.oldContract
    : store.getState().sellingFormDetails;
  let adjective = "";

  const userInArr = sellingFormDetails[options.parentFieldName].find(
    (item) => item.partyId === userInfo?.nationalId,
  );
  // if (rowData?.partyId === userInfo?.nationalId || userInArr) {
  // if (rowData?.partyId === "9931011342") {
  if (userInArr) {
    if (rowData.adjective == -1) {
      adjective = 1;
    } else {
      adjective = rowData.adjective || 1;
    }
  } else {
    if (rowData.adjective == 1) {
      adjective = -1;
    } else {
      adjective = rowData.adjective || -1;
    }
  }

  if (
    options.parentFieldName &&
    typeof options.rowIndex === "number" &&
    (typeof sellingFormDetails[options.parentFieldName][options.rowIndex]
      .adjective === "undefined" ||
      sellingFormDetails[options.parentFieldName][options.rowIndex]
        .adjective !== rowData.adjective ||
      adjective !== rowData.adjective)
  ) {
    const tempParentFieldName = JSON.parse(
      JSON.stringify(sellingFormDetails[options.parentFieldName]),
    );
    tempParentFieldName[options.rowIndex].adjective = adjective;

    store.dispatch(
      updateSellingFormObject({
        ...sellingFormDetails,
        [options.parentFieldName]: tempParentFieldName,
      }),
    );
  }
  // rowData.adjective = adjective
  return configFun().userTypesNew.find((ele) => ele.value === adjective);
};

export function areNumbersApproximatelyEqual(num1, num2, tolerance = 0.01) {
  return Math.abs(num1 - num2) <= tolerance;
}

export function formatNumberWithZeroPadding(number, numberOfDigits) {
  // Convert the number to a string
  let numberString = `${number}`.toString();

  // Calculate the number of zeros to add
  let zerosToAdd = numberOfDigits - numberString.length;

  // Add zeros to the beginning of the string
  for (let i = 0; i < zerosToAdd; i++) {
    numberString = "0" + numberString;
  }

  return numberString;
}

export const courts = [
  {
    label: "محكمة بداية عمان / كاتب عدل شرق عمان",
    value: {
      courtName: "محكمة بداية عمان / كاتب عدل شرق عمان",
      courtCode: "419",
    },
  },
  {
    label: "محكمة بداية عمان / كاتب عدل شمال عمان",
    value: {
      courtName: "محكمة بداية عمان / كاتب عدل شمال عمان",
      courtCode: "420",
    },
  },
  {
    label: "محكمة بداية عمان / كاتب عدل غرب عمان",
    value: {
      courtName: "محكمة بداية عمان / كاتب عدل غرب عمان",
      courtCode: "418",
    },
  },
  {
    label: "الكاتب العدل محكمة بداية عمان",
    value: {
      courtName: "الكاتب العدل محكمة بداية عمان",
      courtCode: "416",
    },
  },
  {
    label: "الكاتب العدل محكمة بداية الكرك",
    value: {
      courtName: "الكاتب العدل محكمة بداية الكرك",
      courtCode: "459",
    },
  },
  {
    label: "الكاتب العدل محكمة بداية السلط",
    value: {
      courtName: "الكاتب العدل محكمة بداية السلط",
      courtCode: "414",
    },
  },
  {
    label: "الكاتب العدل محكمة بداية اربد",
    value: {
      courtName: "الكاتب العدل محكمة بداية اربد",
      courtCode: "412",
    },
  },
  {
    label: "الكاتب العدل محكمة بداية مادبا",
    value: {
      courtName: "الكاتب العدل محكمة بداية مادبا",
      courtCode: "410",
    },
  },
  {
    label: "الكاتب العدل محكمة بداية الطفيلة",
    value: {
      courtName: "الكاتب العدل محكمة بداية الطفيلة",
      courtCode: "409",
    },
  },
  {
    label: "الكاتب العدل محكمة بداية جرش",
    value: {
      courtName: "الكاتب العدل محكمة بداية جرش",
      courtCode: "411",
    },
  },
  {
    label: "الكاتب العدل محكمة بداية الزرقاء",
    value: {
      courtName: "الكاتب العدل محكمة بداية الزرقاء",
      courtCode: "415",
    },
  },
  {
    label: "الكاتب العدل محكمة بداية المفرق",
    value: {
      courtName: "الكاتب العدل محكمة بداية المفرق",
      courtCode: "408",
    },
  },
  {
    label: "الكاتب العدل محكمة بداية معان",
    value: {
      courtName: "الكاتب العدل محكمة بداية معان",
      courtCode: "407",
    },
  },
  {
    label: "الكاتب العدل محكمة بداية عجلون",
    value: {
      courtName: "الكاتب العدل محكمة بداية عجلون",
      courtCode: "406",
    },
  },
  {
    label: "الكاتب العدل محكمة بداية العقبة",
    value: {
      courtName: "الكاتب العدل محكمة بداية العقبة",
      courtCode: "405",
    },
  },
  {
    label: "الكاتب العدل محكمة الشونة الجنوبية",
    value: {
      courtName: "الكاتب العدل محكمة الشونة الجنوبية",
      courtCode: "404",
    },
  },
  {
    label: "الكاتب العدل محكمة ناعور",
    value: {
      courtName: "الكاتب العدل محكمة ناعور",
      courtCode: "403",
    },
  },
  {
    label: "الكاتب العدل محكمة البتراء /وادي موسى",
    value: {
      courtName: "الكاتب العدل محكمة البتراء /وادي موسى",
      courtCode: "402",
    },
  },
  {
    label: "الكاتب العدل محكمة المزار الجنوبي",
    value: {
      courtName: "الكاتب العدل محكمة المزار الجنوبي",
      courtCode: "401",
    },
  },
  {
    label: "الكاتب العدل محكمة بداية الرمثا",
    value: {
      courtName: "الكاتب العدل محكمة بداية الرمثا",
      courtCode: "400",
    },
  },
  {
    label: "الكاتب العدل محكمة القصر",
    value: {
      courtName: "الكاتب العدل محكمة القصر",
      courtCode: "399",
    },
  },
  {
    label: "الكاتب العدل محكمة بداية الرصيفة",
    value: {
      courtName: "الكاتب العدل محكمة بداية الرصيفة",
      courtCode: "398",
    },
  },
  {
    label: "الكاتب العدل محكمة سحاب",
    value: {
      courtName: "الكاتب العدل محكمة سحاب",
      courtCode: "397",
    },
  },
  {
    label: "الكاتب العدل محكمة بني عبيد",
    value: {
      courtName: "الكاتب العدل محكمة بني عبيد",
      courtCode: "396",
    },
  },
  {
    label: "الكاتب العدل محكمة فقوع",
    value: {
      courtName: "الكاتب العدل محكمة فقوع",
      courtCode: "395",
    },
  },
  {
    label: "الكاتب العدل محكمة ذيبان",
    value: {
      courtName: "الكاتب العدل محكمة ذيبان",
      courtCode: "394",
    },
  },
  {
    label: "الكاتب العدل محكمة الحسينية",
    value: {
      courtName: "الكاتب العدل محكمة الحسينية",
      courtCode: "393",
    },
  },
  {
    label: "الكاتب العدل محكمة البادية الشمالية",
    value: {
      courtName: "الكاتب العدل محكمة البادية الشمالية",
      courtCode: "392",
    },
  },
  {
    label: "الكاتب العدل محكمة بني كنانة",
    value: {
      courtName: "الكاتب العدل محكمة بني كنانة",
      courtCode: "391",
    },
  },
  {
    label: "الكاتب العدل محكمة عين الباشا",
    value: {
      courtName: "الكاتب العدل محكمة عين الباشا",
      courtCode: "390",
    },
  },
  {
    label: "الكاتب العدل محكمة الجفر",
    value: {
      courtName: "الكاتب العدل محكمة الجفر",
      courtCode: "389",
    },
  },
  {
    label: "الكاتب العدل محكمة عي",
    value: {
      courtName: "الكاتب العدل محكمة عي",
      courtCode: "388",
    },
  },
  {
    label: "الكاتب العدل محكمة المزار الشمالي",
    value: {
      courtName: "الكاتب العدل محكمة المزار الشمالي",
      courtCode: "387",
    },
  },
  {
    label: "الكاتب العدل محكمة الكورة",
    value: {
      courtName: "الكاتب العدل محكمة الكورة",
      courtCode: "386",
    },
  },
  {
    label: "الكاتب العدل محكمة الجيزة",
    value: {
      courtName: "الكاتب العدل محكمة الجيزة",
      courtCode: "385",
    },
  },
  {
    label: "الكاتب العدل محكمة الشوبك",
    value: {
      courtName: "الكاتب العدل محكمة الشوبك",
      courtCode: "384",
    },
  },
  {
    label: "الكاتب العدل محكمة الغور الصافي",
    value: {
      courtName: "الكاتب العدل محكمة الغور الصافي",
      courtCode: "383",
    },
  },
  {
    label: "الكاتب العدل محكمة الاغوار الشمالية",
    value: {
      courtName: "الكاتب العدل محكمة الاغوار الشمالية",
      courtCode: "382",
    },
  },
  {
    label: "الكاتب العدل محكمة دير علا",
    value: {
      courtName: "الكاتب العدل محكمة دير علا",
      courtCode: "381",
    },
  },
  {
    label: "الكاتب العدل محكمة الموقر",
    value: {
      courtName: "الكاتب العدل محكمة الموقر",
      courtCode: "380",
    },
  },
  {
    label: "الكاتب العدل محكمة الطيبة",
    value: {
      courtName: "الكاتب العدل محكمة الطيبة",
      courtCode: "379",
    },
  },
  {
    label: "الكاتب العدل محكمة القويرة",
    value: {
      courtName: "الكاتب العدل محكمة القويرة",
      courtCode: "378",
    },
  },
  {
    label: "محكمة بداية عمان / كاتب عدل جنوب عمان",
    value: {
      courtName: "محكمة بداية عمان / كاتب عدل جنوب عمان",
      courtCode: "462",
    },
  },
  {
    label: "الكاتب العدل محكمة الجنايات الكبرى",
    value: {
      courtName: "الكاتب العدل محكمة الجنايات الكبرى",
      courtCode: "463",
    },
  },
  {
    label: "الكاتب العدل محكمة الوسطية",
    value: {
      courtName: "الكاتب العدل محكمة الوسطية",
      courtCode: "492",
    },
  },
  {
    label: "الكاتب العدل محكمة الحسا",
    value: {
      courtName: "الكاتب العدل محكمة الحسا",
      courtCode: "493",
    },
  },
  {
    label: "الكاتب العدل محكمة بصيرا",
    value: {
      courtName: "الكاتب العدل محكمة بصيرا",
      courtCode: "500",
    },
  },
  {
    label: "الكاتب العدل محكمة الازرق",
    value: {
      courtName: "الكاتب العدل محكمة الازرق",
      courtCode: "517",
    },
  },
  {
    label: "الكاتب العدل محكمة الرويشد",
    value: {
      courtName: "الكاتب العدل محكمة الرويشد",
      courtCode: "518",
    },
  },
  {
    label: "الكاتب العدل عمان لدى غرفة تجارة عمان",
    value: {
      courtName: "الكاتب العدل عمان لدى غرفة تجارة عمان",
      courtCode: "533",
    },
  },
  {
    label: "الكاتب العدل اربد لدى غرفة تجارة اربد",
    value: {
      courtName: "الكاتب العدل اربد لدى غرفة تجارة اربد",
      courtCode: "558",
    },
  },
  {
    label: "الكاتب العدل الزرقاء لدى غرفة تجارة الزرقاء",
    value: {
      courtName: "الكاتب العدل الزرقاء لدى غرفة تجارة الزرقاء",
      courtCode: "630",
    },
  },
  {
    label: "الكاتب العدل لدى جمعية المستثمرين في قطاع الاسكان الاردني",
    value: {
      courtName: "الكاتب العدل لدى جمعية المستثمرين في قطاع الاسكان الاردني",
      courtCode: "633",
    },
  },
  {
    label: "الكاتب العدل عمان لدى دائرة مراقبة الشركات",
    value: {
      courtName: "الكاتب العدل عمان لدى دائرة مراقبة الشركات",
      courtCode: "634",
    },
  },
  {
    label: "الكاتب العدل لدى محكمة امن الدولة",
    value: {
      courtName: "الكاتب العدل لدى محكمة امن الدولة",
      courtCode: "636",
    },
  },
  {
    label: "الكاتب العدل لدى جمعية البنوك في الاردن",
    value: {
      courtName: "الكاتب العدل لدى جمعية البنوك في الاردن",
      courtCode: "638",
    },
  },
  {
    label: "الكاتب العدل محكمة احداث عمان",
    value: {
      courtName: "الكاتب العدل محكمة احداث عمان",
      courtCode: "761",
    },
  },
  {
    label: "الكاتب العدل المرخص -  وزارة العدل",
    value: {
      courtName: "الكاتب العدل المرخص -  وزارة العدل",
      courtCode: "1013",
    },
  },
  {
    label: "كاتب العدل مركز الخدمات الحكومي - المقابلين",
    value: {
      courtName: "كاتب العدل مركز الخدمات الحكومي - المقابلين",
      courtCode: "1104",
    },
  },
  {
    label: "الكاتب العدل مركز الخدمات الحكومي - العقبة",
    value: {
      courtName: "الكاتب العدل مركز الخدمات الحكومي - العقبة",
      courtCode: "1136",
    },
  },
];

function getCountFromItems(items = [], conditionCallback) {
  let count = 0;
  items.forEach((item) => {
    if (conditionCallback(item)) {
      count++;
    }
  });

  return count;
}

function getDocsArray(countFunc, data, docType, sellingFormDetails) {
  const temp = [];
  const count = countFunc(sellingFormDetails);

  for (let index = 0; index < count; index++) {
    temp.push({
      name: `${t(`realtySelling.${docType}`)} ${index + 1}`,
      file: data[`${docType}${index + 1}`],
      key: `${docType}${index + 1}`,
    });
  }

  return temp;
}

export function getMilitaryDesignationCertificateForOwnerCount(
  sellingFormDetails,
) {
  return getCountFromItems(sellingFormDetails?.selectedShares, (item) => {
    return (
      moment().diff(moment(item.card_expiry)) > 0 &&
      item.personStatus !== "متوفي"
    );
  });
}

export function getMilitaryDesignationCertificateForOwnerDocsArray(
  data,
  sellingFormDetails,
) {
  return getDocsArray(
    getMilitaryDesignationCertificateForOwnerCount,
    data,
    "militaryDesignationCertificateForOwner",
    sellingFormDetails,
  );
}

export function getMilitaryDesignationCertificateForOwnerRefundDocs(
  sellingFormDetails,
) {
  const militaryDesignationCertificateForOwnerDocs = {};
  for (
    let index = 0;
    index < getMilitaryDesignationCertificateForOwnerCount(sellingFormDetails);
    index++
  ) {
    militaryDesignationCertificateForOwnerDocs[
      `militaryDesignationCertificateForOwner${index + 1}`
    ] =
      JSON.parse(
        sellingFormDetails.tempAttach[
        `militaryDesignationCertificateForOwner${index + 1}`
        ] || "{}",
      )?.value || "";
  }
  return militaryDesignationCertificateForOwnerDocs;
}

export function getMilitaryDesignationCertificateForOwnerDocs(
  docIndex,
  sellingFormDetails,
) {
  const temp = {};
  for (
    let index = 0;
    index < getMilitaryDesignationCertificateForOwnerCount(sellingFormDetails);
    index++
  ) {
    temp[`militaryDesignationCertificateForOwner${index + 1}`] =
      sellingFormDetails.attachments[docIndex + index]?.file || "";
  }
  return temp;
}

export async function getAuthData(pRandom, dontUpdateLoading = false) {
  const authData = {
    hasAuthority: false,
  };
  try {
    const belongsToWhichAuthority = await lookups.belongsToWhichAuthority(
      pRandom,
      dontUpdateLoading,
    );
    if (belongsToWhichAuthority.data?.sourceDesc === "PETRA") {
      authData["hasAuthority"] = true;
      authData["Authority_Num"] = 203;
    }
    if (
      belongsToWhichAuthority.data?.sourceDesc === "JAV" ||
      belongsToWhichAuthority.data?.sourceDesc === "JVA"
    ) {
      authData["hasAuthority"] = true;
      authData["Authority_Num"] = 201;
    }
  } catch (error) { }

  return authData;
}

const appendAttachmentsAgency = (item, oldData, id = "") => {
  if (oldData[`attachAgency_${id}`]) {
    item["attachAgency"] = JSON.parse(
      oldData[`attachAgency_${id}`] || "{}",
    )?.value;
  }
  if (oldData[`attachAgency2_${id}`]) {
    item["attachAgency2"] = JSON.parse(
      oldData[`attachAgency2_${id}`] || "{}",
    )?.value;
  }
};
const appendAttachmentsDeputy = (item, oldData, id = "") => {
  if (oldData[`deputyAttach_${id}`]) {
    item["deputyAttach"] = JSON.parse(
      oldData[`deputyAttach_${id}`] || "{}",
    )?.value;
  }
};
const appendAttachmentsGuardian = (item, oldData, id = "") => {
  item.selectedArguments?.forEach((selectedArgument) => {
    if (+selectedArgument.mainArgumentTypeCode === 4) {
      if (
        oldData[
        `salesAuthorizationAttachment_${selectedArgument.secondaryArgumentTypeCode}_${id}`
        ]
      ) {
        item[
          `salesAuthorizationAttachment_${selectedArgument.secondaryArgumentTypeCode}`
        ] = JSON.parse(
          oldData[
          `salesAuthorizationAttachment_${selectedArgument.secondaryArgumentTypeCode}_${id}`
          ] || "{}",
        )?.value;
      }
    }
  });
  if (oldData[`guardianshipAttachment_${id}`]) {
    item["guardianshipAttachment"] = JSON.parse(
      oldData[`guardianshipAttachment_${id}`] || "{}",
    )?.value;
  }
};
export const appendAttachmentsToData = (data, oldData, merge = false) => {
  if (oldData[`clearanceAttachment`]) {
    data["clearanceAttachment"] = JSON.parse(
      oldData[`clearanceAttachment`] || "{}",
    )?.value;
  }
  if (merge) {
    data["detectionResultAttach"] = {};
    data["referencePointsAttach"] = {};
    data["fieldMonitoringForm"] = {};
    data["fieldMonitoringFormPdf"] = {};

    data.propertiesDetails.forEach((item) => {
      if (oldData[item.pRandom]) {
        if (oldData[item.pRandom][`detectionResultAttach`]) {
          data["detectionResultAttach"][item.pRandom] =
            oldData[item.pRandom][`detectionResultAttach`];
        }
        if (oldData[item.pRandom][`referencePointsAttach`]) {
          data["referencePointsAttach"][item.pRandom] =
            oldData[item.pRandom][`referencePointsAttach`];
        }
        if (oldData[item.pRandom][`fieldMonitoringForm`]) {
          data["fieldMonitoringForm"][item.pRandom] =
            oldData[item.pRandom][`fieldMonitoringForm`];
        }
        if (oldData[item.pRandom][`fieldMonitoringFormPdf`]) {
          data["fieldMonitoringFormPdf"][item.pRandom] =
            oldData[item.pRandom][`fieldMonitoringFormPdf`];
        }
      }
    });
  } else {
    if (oldData[`referencePointsAttach_${data.propertyData.pRandom}`]) {
      data["referencePointsAttach"] = {};
      data["referencePointsAttach"][data.propertyData.pRandom] = JSON.parse(
        oldData[`referencePointsAttach_${data.propertyData.pRandom}`] || "{}",
      )?.value;
    }
    if (oldData[`fieldMonitoringForm_${data.propertyData.pRandom}`]) {
      data["fieldMonitoringForm"] = {};
      data["fieldMonitoringForm"][data.propertyData.pRandom] = JSON.parse(
        oldData[`fieldMonitoringForm_${data.propertyData.pRandom}`] || "{}",
      )?.value;
    }
    if (oldData[`fieldMonitoringFormPdf_${data.propertyData.pRandom}`]) {
      data["fieldMonitoringFormPdf"] = {};
      data["fieldMonitoringFormPdf"][data.propertyData.pRandom] = JSON.parse(
        oldData[`fieldMonitoringFormPdf_${data.propertyData.pRandom}`] || "{}",
      )?.value;
    }
    if (oldData[`detectionResultAttach_${data.propertyData.pRandom}`]) {
      data["detectionResultAttach"] = {};
      data["detectionResultAttach"][data.propertyData.pRandom] = JSON.parse(
        oldData[`detectionResultAttach_${data.propertyData.pRandom}`] || "{}",
      )?.value;
    }
  }
  if (data.selectedShares) {
    data.selectedShares.forEach((item) => {
      appendAttachmentsAgency(item, oldData, item.partyId || item.passport_no);
      appendAttachmentsDeputy(item, oldData, item.partyId || item.passport_no);
      appendAttachmentsGuardian(
        item,
        oldData,
        item.partyId || item.passport_no,
      );
    });
  }

  return data;
};

export const investmentApprovalAttachVilCodes = [
  637, // العقبة
  641, // الساحل الجنوبي
  648, // وادي اليتم
  653, // الشهيبي
  652, // ام سلب
  643, // الغال
  1172, // الطويل
  640, // الراشدية
  778, // الثغرة
  650, // رامان
  649, // رم
  647, // منيشير
  678, // تتن
  644, // القويره
  642, // الطويسه
  651, // سهل الصوان
  639, // الديسه
];

export const countRequiredToSignAcknowledgment = (
  formData,
  fieldNamesToCount,
) => {
  const countRequiredToSign = {
    count: 0,
    haveAgent: false,
  };

  for (const fieldName of fieldNamesToCount) {
    const arr = formData[fieldName];

    if (arr && Array.isArray(arr)) {
      for (const personData of arr) {
        if (+personData.adjective !== 2) {
          countRequiredToSign.count++;
        }
        if (+personData.adjective === 2) {
          countRequiredToSign.count++;
          countRequiredToSign.haveAgent = true;

          if (personData.agentsList && Array.isArray(personData.agentsList)) {
            for (const agent of personData.agentsList) {
              countRequiredToSign.count++;
            }
          }
        }
      }
    }
  }

  return countRequiredToSign;
};

export function generateUUID() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16),
  );
}

export function getRegisteredWithPropertyCreateMethodByType(type) {
  if (type === "withLandPlan") {
    return newPropertyPlanWithRegisteredReport;
  }
  if (type === "withLandPlanAndCoordinates") {
    return newRegisteredPropertyWithPropertyPlanAndCoordinates;
  }
  if (type === "withLandPlanAndChangeStatement") {
    return newRegisteredWithPropertyPlanAndChangeStatement;
  }
  if (type === "withLandPlanChangeStatementAndCoordinates") {
    return newRegisteredPropertyWithPropertyPlanAndCoordinatesAndChangeStatement;
  }
  return newRegisteredProperty;
}

export function formatDate(dateStr) {
  const date = new Date(dateStr);

  return date
    .toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    .replace(",", " -");
}

export const showElectricityClearance = (sellingFormDetails) => {
  if (isFlat(sellingFormDetails.propertyData.prcL_TYPE)) {
    return true;
  }

  if (
    sellingFormDetails.hasBelongings ||
    sellingFormDetails.hasDemolishedBuilding
  ) {
    return true;
  }

  return false;
};

export function deepTrim(value) {
  if (typeof value === "string") {
    return value.trim();
  }

  if (Array.isArray(value)) {
    return value.map((item) => deepTrim(item));
  }

  if (value !== null && typeof value === "object") {
    const result = {};
    for (const key in value) {
      if (value.hasOwnProperty(key)) {
        result[key] = deepTrim(value[key]);
      }
    }
    return result;
  }

  // return other types (number, boolean, null, undefined) as-is
  return value;
}

export function downloadBase64File(base64, fileName = "attachment") {
  if (!base64) return;

  // Ensure proper data URL format
  const formatted = base64.startsWith("data:")
    ? base64
    : `data:application/octet-stream;base64,${base64}`;

  // Extract MIME type
  const mimeMatch = formatted.match(/^data:(.*?);base64,/);
  const mime = mimeMatch ? mimeMatch[1] : "application/octet-stream";

  // Map MIME types to extensions
  const mimeToExt = {
    "application/pdf": "pdf",
    "image/png": "png",
    "image/jpeg": "jpg",
    "image/jpg": "jpg",
    "image/gif": "gif",
    "image/webp": "webp",
    "text/plain": "txt",
    "text/csv": "csv",
    "application/json": "json",
    "application/zip": "zip",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      "docx",
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.ms-excel": "xls",
  };

  const extension = mimeToExt[mime] || "bin";

  // Create link
  const link = document.createElement("a");
  link.href = formatted;
  link.download = `${fileName}.${extension}`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
